import React, { useState, useEffect, useCallback } from 'react';
import { API_URL, fmtFecha } from '../constants';
import { KPI, Input, Select, SelectSearchable, SeccionLabel, InfoCampo } from './shared';

// Helper function for Mexican currency formatting
const formatCurrencyMX = (valor) => {
  if (!valor) return '$0';
  const num = parseFloat(valor);
  return `$${num.toLocaleString('es-MX')}`;
};

export function Reclutamiento() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [kpis, setKpis] = useState({
    vacantesAbiertas: 0,
    preAltas: 0,
    ingresosEsteMes: 0,
    costoAgencias: 0,
    costoInterno: 0,
    bonosPendientes: 0,
    kmAvanza: 0
  });

  // Documentos Tab state
  const [filtroSucursal, setFiltroSucursal] = useState('');
  const [soloFaltantes, setSoloFaltantes] = useState(false);
  const [docsEditables, setDocsEditables] = useState({});

  // PRE-ALTAS state
  const [paso, setPaso] = useState(1);
  const [formData, setFormData] = useState({
    sucursal: '',
    apellido_paterno: '',
    apellido_materno: '',
    nombres: '',
    telefono: '',
    email: '',
    ubicacion_fisica: '',
    centro_costos: '',
    nodo_id: '',
    puesto_previsto: '',
    turno_id: '',
    fecha_entrevista: '',
    hora_entrevista: '',
    entrevistador_rh: '',
    entrevistador_gerente: '',
    puntuacion: '',
    fuente_reclutamiento: '',
    recomendado_por_empleado_id: '',
    recomendado_por_nombre: '',
    documento_completo: {
      comprobante_domicilio: false,
      constancia_fiscal: false,
      comprobante_estudios: false,
      seguro_social: false,
      acta_nacimiento: false,
      identificacion_ine: false,
      curp: false
    },
    experiencia_anos: '',
    disponibilidad_inicio: '',
    comentarios: ''
  });

  // Cascadas state
  const [catalagosCargados, setCatalogosCargados] = useState(false);
  const [sucursalesList, setSucursalesList] = useState([]);
  const [ubicacionesList, setUbicacionesList] = useState([]);
  const [centrosList, setCentrosList] = useState([]);
  const [nodosList, setNodosList] = useState([]);
  const [puestosList, setPuestosList] = useState([]);
  const [turnosList, setTurnosList] = useState([]);
  const [personalRHList, setPersonalRHList] = useState([]);
  const [gerentesList, setGerentesList] = useState([]);
  const [empleadosList, setEmpleadosList] = useState([]);
  const [prealtasData, setPrealtasData] = useState([]);
  const [filtros, setFiltros] = useState({
    estado: '',
    fuente: '',
    puesto: ''
  });
  const [sortConfig, setSortConfig] = useState({ key: 'fecha_creacion', direction: 'desc' });
  const [editando, setEditando] = useState(null);
  const [showHistorial, setShowHistorial] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [formErrors, setFormErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');

  // PROCESAR ALTA state
  const [mostrarSelectorModal, setMostrarSelectorModal] = useState(false);
  const [mostrarNuevoIngresoModal, setMostrarNuevoIngresoModal] = useState(false);
  const [tabNuevoIngreso, setTabNuevoIngreso] = useState(1);
  const [pasoAlta, setPasoAlta] = useState(1);
  const [salarioMode, setSalarioMode] = useState('mensual'); // 'mensual' | 'diario'
  const [altaData, setAltaData] = useState({
    prealta_id: '',
    prealtaDetails: null,
    id_empleado: '',
    curp: '',
    rfc: '',
    sucursal_final: '',
    ubicacion_final: '',
    centro_final: '',
    nodo_final: '',
    puesto_final: '',
    fecha_ingreso: new Date().toISOString().split('T')[0],
    salario_base: '',
    salario_diario: '',
    domicilio: {},
    nodo_id: '',
    area_final: '',
    agencia_id: '',
    garantiaTerms: null,
    bonusTerms: null,
    recomendador_id: '',
    valesDespensa: '600'
  });
  const [prealtasDisponibles, setPrealtasDisponibles] = useState([]);
  const [nodosDisponibles, setNodosDisponibles] = useState([]);
  const [agenciasData, setAgenciasData] = useState([]);
  const [altaFormErrors, setAltaFormErrors] = useState({});
  const [altaSuccessData, setAltaSuccessData] = useState(null);
  const [generatedPdfUrl, setGeneratedPdfUrl] = useState(null);
  const [altaConfirmGarantia, setAltaConfirmGarantia] = useState(false);
  const [altaConfirmBonus, setAltaConfirmBonus] = useState(false);

  // GARANTIAS Tab state
  const [tabGarantias, setTabGarantias] = useState('garantias'); // 'garantias' | 'bonos' | 'reportes'

  // Garantías Sub-Tab state
  const [garantiasData, setGarantiaData] = useState([]);
  const [filtroGarantia, setFiltroGarantia] = useState({
    agencia: '',
    estado: ''
  });
  const [showDetalleGarantia, setShowDetalleGarantia] = useState(null);

  // Bonos Sub-Tab state
  const [bonosData, setBonosData] = useState([]);
  const [filtroBono, setFiltroBono] = useState({
    estado_primer: '',
    estado_segundo: ''
  });
  const [showConfirmPago, setShowConfirmPago] = useState(null);
  const [loadingBono, setLoadingBono] = useState(false);

  // Reportes Sub-Tab state
  const [reporteType, setReporteType] = useState('garantias'); // 'garantias' | 'gastos' | 'avanza'
  const [periodoReporte, setPeriodoReporte] = useState('mes-actual');
  const [reporteData, setReporteData] = useState(null);

  // Control AVANZA state
  // Note: Dashboard alerts state removed - alerts now always visible
  const [formControl, setFormControl] = useState({
    quien_salio: '',
    fecha: new Date().toISOString().split('T')[0],
    horario_salida: '',
    horario_entrada: '',
    km_inicio: '',
    km_fin: '',
    costo_km: 10,
    donde_fue: '',
    prospectos_contactados: '',
    volantes_repartidos: '',
    gastos_viaticos: 0,
    gastos_diesel: 0,
    gastos_otros: 0,
    resultados_notas: '',
    notas: ''
  });
  const [controlData, setControlData] = useState([]);
  const [filtroControl, setFiltroControl] = useState({
    agente: '',
    periodo: '' // 'semana' o 'mes'
  });
  const [calculosControl, setCalculosControl] = useState({
    km_recorridos: 0,
    costo_total_dia: 0
  });
  const [sortControl, setSortControl] = useState({ key: 'fecha', direction: 'desc' });
  const [showDetalleControl, setShowDetalleControl] = useState(null);
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [formControlErrors, setFormControlErrors] = useState({});
  const [showFormControlModal, setShowFormControlModal] = useState(false);

  // Estados disponibles
  const ESTADOS_PREALTA = ['Nuevo', 'Entrevistado', 'En revisión', 'Programado a ingreso', 'Rechazado', 'No se presentó', 'Espera aviso', 'En negociación'];
  const FUENTES_RECLUTAMIENTO = ['WhatsApp', 'Facebook', 'LinkedIn', 'Referencia', 'Agencia JH Capital', 'Celta Consultores', 'Otro'];

  useEffect(() => {
    cargarKPIs();
    cargarPrealtas();
    cargarCatalogos(); // Cargar cascadas para PRE-ALTA
    if (activeTab === 'procesar-alta') {
      cargarPrealtasDisponibles();
      cargarNodos();
    }
    if (activeTab === 'garantias') {
      cargarGarantias();
      cargarBonos();
    }
    if (activeTab === 'control-avanza') {
      cargarControlesAvanza();
    }
  }, [activeTab]);

  // Cargar catálogos cuando se abre Procesar Alta
  useEffect(() => {
    if (activeTab === 'procesar-alta' && !catalagosCargados) {
      cargarCatalogos();
    }
  }, [activeTab, catalagosCargados]);

  // Cargar documentos solo una vez cuando se abre la pestaña
  useEffect(() => {
    if (activeTab === 'documentos') {
      cargarDocumentosDesdeBackend();
    }
  }, [activeTab]);

  const cargarKPIs = async () => {
    setLoading(true);
    setError(null);
    try {
      const [nodosRes, prealtasRes, garantiasRes, gastosRes, avanzaRes] = await Promise.all([
        fetch(API_URL + '?path=api/reclutamiento/nodos-abiertos'),
        fetch(API_URL + '?path=api/reclutamiento/listar-prealtas'),
        fetch(API_URL + '?path=api/reclutamiento/reporte-garantias-agencia'),
        fetch(API_URL + '?path=api/reclutamiento/reporte-gastos-totales'),
        fetch(API_URL + '?path=api/reclutamiento/reporte-control-avanza')
      ]);

      const nodosData = await nodosRes.json();
      const prealtasData = await prealtasRes.json();
      const garantiasData = await garantiasRes.json();
      const gastosData = await gastosRes.json();
      const avanzaData = await avanzaRes.json();

      const vacantesAbiertas = (nodosData.data || []).filter(n => n.estado_vacante === 'Abierta').length;
      const preAltas = (prealtasData.data || []).length;
      const ingresosEsteMes = (prealtasData.data || []).filter(p => p.estado_prealta === 'Programado a ingreso').length;

      let costoAgencias = 0;
      (garantiasData.data || []).forEach(g => {
        costoAgencias += (g.costo_ingreso || 0);
      });

      let costoInterno = 0;
      (gastosData.data || []).forEach(g => {
        costoInterno += (g.monto || 0);
      });

      let bonosPendientes = 0;
      (prealtasData.data || []).forEach(p => {
        if (p.recomendado_por_empleado_id) {
          bonosPendientes += 1000;
        }
      });
      bonosPendientes *= 1000;

      let kmAvanza = 0;
      (avanzaData.data || []).forEach(a => {
        kmAvanza += (a.km_recorridos || 0);
      });

      setKpis({
        vacantesAbiertas,
        preAltas,
        ingresosEsteMes,
        costoAgencias,
        costoInterno,
        bonosPendientes,
        kmAvanza
      });
    } catch (err) {
      console.error('Error cargando KPIs:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const calcularTasaConversion = () => {
    if (kpis.preAltas > 0) {
      return ((kpis.ingresosEsteMes / kpis.preAltas) * 100).toFixed(1);
    }
    return 0;
  };

  // Documentos toggle - NO depende de docsEditables para evitar recreación
  const toggleDoc = useCallback(async (prealtaId, doc) => {
    const key = `${prealtaId}-${doc}`;

    // Actualizar estado local usando función para capturar estado actual
    setDocsEditables(prevState => {
      const estadoActual = prevState[key] || false;
      const nuevoEstado = !estadoActual;

      // Construir docs16 basado en prevState actualizado
      const listaDocs = ['domicilio', 'fiscal', 'estudios', 'imss', 'acta', 'ine', 'curp',
                         'reglamentos', 'actualizacion_datos', 'carta_adeudos', 'checklist',
                         'confidencialidad', 'contrato_laboral', 'equipo_seguridad', 'gafete', 'reglamento_interno'];

      const docs16 = {};
      listaDocs.forEach(docKey => {
        const docKey_full = `${prealtaId}-${docKey}`;
        if (docKey === doc) {
          docs16[docKey] = nuevoEstado;
        } else {
          docs16[docKey] = prevState[docKey_full] || false;
        }
      });

      // Guardar en backend (sin await aquí para no bloquear)
      fetch(API_URL + '?path=api/reclutamiento/actualizar-documento', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          prealta_id: prealtaId,
          documentos: docs16
        })
      }).then(r => r.json()).then(result => {
        if (!result.success) {
          console.error('❌ Error al guardar:', result.error);
          setDocsEditables(p => ({ ...p, [key]: !nuevoEstado }));
        } else {
          console.log('✅ Documento guardado:', prealtaId, doc);
        }
      }).catch(err => {
        console.error('Error guardando documento:', err);
        setDocsEditables(p => ({ ...p, [key]: !nuevoEstado }));
      });

      // Retornar nuevo estado inmediatamente
      return { ...prevState, [key]: nuevoEstado };
    });
  }, []);

  // Cargar documentos desde backend al abrir pestaña
  const cargarDocumentosDesdeBackend = async () => {
    try {
      const response = await fetch(API_URL + '?path=api/reclutamiento/obtener-documentos&filtroTipo=PRE-ALTA');
      const result = await response.json();
      if (result.success && result.documentos) {
        const newDocsState = {};
        result.documentos.forEach(doc => {
          newDocsState[`${doc.id_documento}-domicilio`] = doc.domicilio;
          newDocsState[`${doc.id_documento}-fiscal`] = doc.fiscal;
          newDocsState[`${doc.id_documento}-estudios`] = doc.estudios;
          newDocsState[`${doc.id_documento}-imss`] = doc.imss;
          newDocsState[`${doc.id_documento}-acta`] = doc.acta;
          newDocsState[`${doc.id_documento}-ine`] = doc.ine;
          newDocsState[`${doc.id_documento}-curp`] = doc.curp;
          newDocsState[`${doc.id_documento}-reglamentos`] = doc.reglamentos;
          newDocsState[`${doc.id_documento}-actualizacion_datos`] = doc.actualizacion_datos;
          newDocsState[`${doc.id_documento}-carta_adeudos`] = doc.carta_adeudos;
          newDocsState[`${doc.id_documento}-checklist`] = doc.checklist;
          newDocsState[`${doc.id_documento}-confidencialidad`] = doc.confidencialidad;
          newDocsState[`${doc.id_documento}-contrato_laboral`] = doc.contrato_laboral;
          newDocsState[`${doc.id_documento}-equipo_seguridad`] = doc.equipo_seguridad;
          newDocsState[`${doc.id_documento}-gafete`] = doc.gafete;
          newDocsState[`${doc.id_documento}-reglamento_interno`] = doc.reglamento_interno;
        });
        setDocsEditables(newDocsState);
        console.log('✅ Documentos cargados desde backend:', newDocsState);
      }
    } catch (err) {
      console.error('Error cargando documentos:', err);
    }
  };

  // PRE-ALTAS Functions
  const cargarPrealtas = async () => {
    try {
      setLoading(true);
      const response = await fetch(API_URL + '?path=api/reclutamiento/listar-prealtas');
      const data = await response.json();
      setPrealtasData(data.data || []);
    } catch (err) {
      console.error('Error cargando PRE-ALTAS:', err);
      setError('Error al cargar PRE-ALTAS');
    } finally {
      setLoading(false);
    }
  };

  // CASCADAS: Cargar catálogos para formularios
  const cargarCatalogos = async () => {
    if (catalagosCargados) return;
    try {
      const [catalogsRes, empleadosRes] = await Promise.all([
        fetch(API_URL + '?path=api/catalogos'),
        fetch(API_URL + '?path=api/empleados')
      ]);
      const catalogsData = await catalogsRes.json();
      const empleadosData = await empleadosRes.json();

      if (catalogsData.success) {
        setSucursalesList(catalogsData.sucursales || []);
        setUbicacionesList(catalogsData.ubicaciones_fisicas || []);
        setCentrosList(catalogsData.centros_costos || []);
        setNodosList(catalogsData.posiciones_nodos || []);
        setPuestosList(catalogsData.puestos || []);
        setTurnosList(catalogsData.turnos || []);
        setPersonalRHList(catalogsData.personal_rh || []);
        setGerentesList(catalogsData.gerentes || []);

        if (empleadosData.success && empleadosData.empleados) {
          setEmpleadosList(empleadosData.empleados);
        }
        setCatalogosCargados(true);

        console.log('✅ Catálogos cargados:', {
          sucursales: catalogsData.sucursales?.length,
          ubicaciones: catalogsData.ubicaciones_fisicas?.length,
          centros: catalogsData.centros_costos?.length,
          nodos: catalogsData.posiciones_nodos?.length,
          puestos: catalogsData.puestos?.length,
          personalRH: catalogsData.personal_rh?.length,
          gerentes: catalogsData.gerentes?.length,
          empleados: empleadosData.empleados?.length
        });
        console.log('📊 Datos completos:', catalogsData);
      }
    } catch (err) {
      console.error('Error cargando catálogos:', err);
    }
  };

  // CASCADAS: Obtener ubicaciones de una sucursal
  const obtenerUbicacionesPorSucursal = (sucursal) => {
    if (!sucursal) return [];
    return ubicacionesList.filter(u => u.Sucursal === sucursal);
  };

  // CASCADAS: Obtener centros de una sucursal (eliminar duplicados)
  const obtenerCentrosPorSucursal = (sucursal) => {
    if (!sucursal) return [];
    const centros = centrosList.filter(c => c.Sucursal === sucursal);
    // Eliminar duplicados por Centro_Costos
    const seen = new Set();
    return centros.filter(c => {
      if (seen.has(c.Centro_Costos)) return false;
      seen.add(c.Centro_Costos);
      return true;
    });
  };

  // CASCADAS: Obtener centros de una ubicación (eliminar duplicados)
  const obtenerCentrosPorUbicacion = (ubicacionId) => {
    if (!ubicacionId) return [];
    const ubicacion = ubicacionesList.find(u => u.ID_Ubicacion === ubicacionId);
    if (!ubicacion) return [];
    const centros = centrosList.filter(c => c.Ubicacion_Fisica === ubicacion.Nombre_Ubicacion);
    // Eliminar duplicados por Centro_Costos
    const seen = new Set();
    return centros.filter(c => {
      if (seen.has(c.Centro_Costos)) return false;
      seen.add(c.Centro_Costos);
      return true;
    });
  };

  // CASCADAS: Obtener nodos de un centro (usar el nombre del centro, no ID)
  const obtenerNodosPorCentro = (centroId) => {
    if (!centroId) return [];
    const centro = centrosList.find(c => c.ID_Centro === centroId);
    if (!centro) return [];
    // Filtrar por nombre del centro exactamente
    return nodosList.filter(n => n.Centro_Costos && String(n.Centro_Costos).trim() === String(centro.Centro_Costos).trim());
  };

  // CASCADAS: Obtener puestos de un centro (desde nodos)
  const obtenerPuestosDelCentro = (centroId) => {
    if (!centroId) return [];
    const nodos = obtenerNodosPorCentro(centroId);
    if (nodos.length === 0) return [];
    // Extraer puestos únicos de los nodos
    const seen = new Set();
    return nodos.filter(n => {
      const key = n.ID_Puesto || n.Nombre_Puesto;
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  // CASCADAS: Obtener turnos de una sucursal (basada en ubicación)
  const obtenerTurnosPorSucursal = (ubicacionId) => {
    if (!ubicacionId) return [];
    const ubicacion = ubicacionesList.find(u => u.ID_Ubicacion === ubicacionId);
    if (!ubicacion) return [];
    return turnosList.filter(t => t.Sucursal === ubicacion.Sucursal);
  };

  const validarPaso = (stepNum) => {
    const errors = {};

    if (stepNum === 1) {
      if (!formData.apellido_paterno.trim()) errors.apellido_paterno = 'Requerido';
      if (!formData.apellido_materno.trim()) errors.apellido_materno = 'Requerido';
      if (!formData.nombres.trim()) errors.nombres = 'Requerido';
      if (!formData.telefono.trim()) errors.telefono = 'Requerido';
      if (formData.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) errors.email = 'Email inválido';
      if (!formData.puesto_previsto.trim()) errors.puesto_previsto = 'Requerido';
    } else if (stepNum === 3) {
      if (!formData.fuente_reclutamiento) errors.fuente_reclutamiento = 'Requerido';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const avanzarPaso = () => {
    if (validarPaso(paso)) {
      if (paso < 4) {
        setPaso(paso + 1);
        window.scrollTo(0, 0);
      }
    }
  };

  const retrocederPaso = () => {
    if (paso > 1) {
      setPaso(paso - 1);
      setFormErrors({});
    }
  };

  const cambiarFormData = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (formErrors[field]) {
      setFormErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const guardarPrealta = async () => {
    if (!validarPaso(paso)) return;

    try {
      setLoading(true);
      const dataToSend = {
        ...formData,
        documento_completo: JSON.stringify(
          Object.keys(formData.documento_completo)
            .filter(key => formData.documento_completo[key])
            .map(key => key.replace(/_/g, ' '))
        )
      };
      const response = await fetch(API_URL + '?path=api/reclutamiento/crear-prealta', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dataToSend)
      });
      const result = await response.json();

      if (result.success || result.id_prealta) {
        setSuccessMessage('PRE-ALTA registrada exitosamente');
        resetForm();
        await cargarPrealtas();
        setTimeout(() => setSuccessMessage(''), 3000);
      } else {
        setError(result.error || 'Error al guardar PRE-ALTA');
      }
    } catch (err) {
      console.error('Error creando PRE-ALTA:', err);
      setError('Error al guardar PRE-ALTA');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      sucursal: '',
      apellido_paterno: '',
      apellido_materno: '',
      nombres: '',
      telefono: '',
      email: '',
      ubicacion_fisica: '',
      centro_costos: '',
      nodo_id: '',
      puesto_previsto: '',
      turno_id: '',
      fecha_entrevista: '',
      hora_entrevista: '',
      entrevistador_rh: '',
      entrevistador_gerente: '',
      puntuacion: '',
      fuente_reclutamiento: '',
      recomendado_por_empleado_id: '',
      recomendado_por_nombre: '',
      documento_completo: {
        comprobante_domicilio: false,
        constancia_fiscal: false,
        comprobante_estudios: false,
        seguro_social: false,
        acta_nacimiento: false,
        identificacion_ine: false,
        curp: false
      },
      experiencia_anos: '',
      disponibilidad_inicio: '',
      comentarios: ''
    });
    setPaso(1);
    setFormErrors({});
  };

  const actualizarPrealta = async (prealtaId, updates) => {
    try {
      setLoading(true);
      const response = await fetch(
        API_URL + `?path=api/reclutamiento/actualizar-prealta`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ prealta_id: prealtaId, ...updates })
        }
      );
      const result = await response.json();

      if (result.success || result.id_prealta) {
        setSuccessMessage('PRE-ALTA actualizada exitosamente');
        setEditando(null);
        await cargarPrealtas();
        setTimeout(() => setSuccessMessage(''), 3000);
      } else {
        setError(result.error || 'Error al actualizar PRE-ALTA');
      }
    } catch (err) {
      console.error('Error actualizando PRE-ALTA:', err);
      setError('Error al actualizar PRE-ALTA');
    } finally {
      setLoading(false);
    }
  };

  // PROCESAR ALTA Functions
  const cargarPrealtasDisponibles = async () => {
    try {
      const response = await fetch(API_URL + '?path=api/reclutamiento/listar-prealtas&estado=Programado%20a%20ingreso');
      const data = await response.json();
      setPrealtasDisponibles(data.data || []);
    } catch (err) {
      console.error('Error cargando PRE-ALTAS disponibles:', err);
    }
  };

  const cargarNodos = async () => {
    try {
      const response = await fetch(API_URL + '?path=api/reclutamiento/nodos-abiertos');
      const data = await response.json();
      setNodosDisponibles(data.data || []);
    } catch (err) {
      console.error('Error cargando nodos:', err);
    }
  };

  const calcularSalarioDesglose = (salarioBase) => {
    if (!salarioBase || salarioBase <= 0) return null;
    const base = parseFloat(salarioBase);
    const diario = base / 30.4;
    const bonoRecomendacion = 200;
    const fondoAhorro = (base * 0.04).toFixed(2);
    return {
      diario: diario.toFixed(2),
      semanal: (diario * 7).toFixed(2),
      mensual: base.toFixed(2),
      bonoRecomendacion: bonoRecomendacion.toFixed(2),
      fondoAhorro: parseFloat(fondoAhorro).toFixed(2),
      totalConBonos: (base + bonoRecomendacion).toFixed(2)
    };
  };

  const validarPasoAlta = (stepNum) => {
    const errors = {};

    if (stepNum === 1) {
      if (!altaData.prealta_id) errors.prealta_id = 'Debe seleccionar un candidato';
    } else if (stepNum === 2) {
      if (!altaData.id_empleado?.trim()) errors.id_empleado = 'ID Empleado requerido';
      if (!altaData.nombres?.trim()) errors.nombres = 'Nombres requeridos';
      if (!altaData.apellido_paterno?.trim()) errors.apellido_paterno = 'Apellido paterno requerido';
      if (!altaData.curp || altaData.curp.length !== 18) errors.curp = 'CURP debe tener 18 caracteres';
      if (!altaData.rfc || altaData.rfc.length !== 13) errors.rfc = 'RFC debe tener 13 caracteres';
      if (!altaData.telefono?.trim()) errors.telefono = 'Teléfono requerido';
      if (!altaData.sucursal_final) errors.sucursal_final = 'Sucursal requerida';
      if (!altaData.ubicacion_final) errors.ubicacion_final = 'Ubicación requerida';
      if (!altaData.centro_final) errors.centro_final = 'Centro de costos requerido';
      if (!altaData.nodo_final) errors.nodo_final = 'Nodo requerido';
      if (!altaData.puesto_final?.trim()) errors.puesto_final = 'Puesto requerido';
      if (!altaData.domicilio?.calle?.trim()) errors.calle = 'Calle requerida';
      if (!altaData.domicilio?.numero?.trim()) errors.numero = 'Número requerido';
      if (!altaData.domicilio?.colonia?.trim()) errors.colonia = 'Colonia requerida';
      if (!altaData.domicilio?.ciudad?.trim()) errors.ciudad = 'Ciudad requerida';
      if (!altaData.domicilio?.estado?.trim()) errors.estado = 'Estado requerido';
      if (!altaData.domicilio?.codigo_postal?.trim()) errors.codigo_postal = 'Código postal requerido';
    } else if (stepNum === 3) {
      if (!altaData.nodo_id) errors.nodo_id = 'Requerido';
      if (!altaData.puesto_final?.trim()) errors.puesto_final = 'Requerido';
      if (!altaData.area_final?.trim()) errors.area_final = 'Requerido';
    } else if (stepNum === 4) {
      if (!altaData.fecha_ingreso) errors.fecha_ingreso = 'Requerido';
      if (salarioMode === 'mensual') {
        if (!altaData.salario_base || parseFloat(altaData.salario_base) <= 0) {
          errors.salario_base = 'Debe ser mayor a 0';
        }
      } else {
        if (!altaData.salario_diario || parseFloat(altaData.salario_diario) <= 0) {
          errors.salario_base = 'Debe ser mayor a 0';
        }
      }
    } else if (stepNum === 5) {
      if (!altaConfirmGarantia) errors.garantia = 'Debe confirmar los términos';
    } else if (stepNum === 6) {
      if (altaData.recomendador_id && !altaConfirmBonus) {
        errors.bonus = 'Debe confirmar los términos del bono';
      }
    }

    setAltaFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const avanzarPasoAlta = () => {
    if (validarPasoAlta(pasoAlta)) {
      if (pasoAlta < 7) {
        setPasoAlta(pasoAlta + 1);
        window.scrollTo(0, 0);
      }
    }
  };

  const retrocederPasoAlta = () => {
    if (pasoAlta > 1) {
      setPasoAlta(pasoAlta - 1);
      setAltaFormErrors({});
    }
  };

  const seleccionarPrealta = (prealtaId) => {
    const prealta = prealtasDisponibles.find(p => String(p.id_prealta) === String(prealtaId));
    if (prealta) {
      // Convertir ID de sucursal a nombre para las cascadas
      const sucursalNombre = sucursalesList.find(s => s.ID_Sucursal === prealta.sucursal)?.Nombre || '';

      setAltaData(prev => ({
        ...prev,
        prealta_id: prealtaId,
        prealtaDetails: prealta,
        nombres: prealta.nombre || '',
        apellido_paterno: prealta.apellido_paterno || '',
        apellido_materno: prealta.apellido_materno || '',
        email: prealta.email || '',
        telefono: prealta.telefono || '',
        sucursal_final: sucursalNombre || '',
        ubicacion_final: prealta.ubicacion_fisica || '',
        puesto_final: prealta.puesto_previsto || '',
        area_final: prealta.area_prosp || prealta.area_prevista || '',
        salario_base: '',
        salario_diario: '',
        agencia_id: '',
        recomendador_id: prealta.recomendado_por_empleado_id || ''
      }));
      setAltaFormErrors({});
      setSalarioMode('mensual');
      setPasoAlta(2);
    }
  };

  const crearAltaFromWizard = async () => {
    if (!validarPasoAlta(6)) return;

    try {
      setLoading(true);

      let salarioBase = altaData.salario_base;
      if (salarioMode === 'diario') {
        salarioBase = parseFloat(altaData.salario_diario) * 30.4;
      }

      const sucursalId = sucursalesList.find(s => s.Nombre === altaData.sucursal_final)?.ID_Sucursal || altaData.sucursal_final;

      const payload = {
        prealta_id: altaData.prealta_id,
        id_empleado: altaData.id_empleado,
        nombres: altaData.nombres,
        apellido_paterno: altaData.apellido_paterno,
        apellido_materno: altaData.apellido_materno,
        curp: altaData.curp,
        rfc: altaData.rfc,
        email: altaData.email,
        telefono: altaData.telefono,
        sucursal_nomina: sucursalId,
        sucursal_fisica: sucursalId,
        posicion_nodo_id: altaData.nodo_id,
        dom_calle: altaData.domicilio?.calle || '',
        dom_numero_ext: altaData.domicilio?.numero || '',
        dom_numero_int: altaData.domicilio?.apartamento || '',
        dom_colonia: altaData.domicilio?.colonia || '',
        dom_municipio: altaData.domicilio?.ciudad || '',
        dom_estado: altaData.domicilio?.estado || '',
        dom_cp: altaData.domicilio?.codigo_postal || '',
        fecha_ingreso: altaData.fecha_ingreso,
        salario_base: parseFloat(salarioBase),
        puesto_final: altaData.puesto_final,
        area_final: altaData.area_final,
        agencia_id: altaData.agencia_id || null,
        notas: 'Conversión desde PRE-ALTA wizard'
      };

      const response = await fetch(API_URL + '?path=api/reclutamiento/crear-alta', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await response.json();

      if (result.success || result.empleado_id) {
        setAltaSuccessData({
          empleado_id: result.empleado_id,
          nombre: altaData.prealtaDetails.nombre,
          puesto_final: altaData.puesto_final,
          salario_base: salarioBase,
          fecha_ingreso: altaData.fecha_ingreso
        });
        setGeneratedPdfUrl(result.pdf_url || null);
      } else {
        setError(result.error || 'Error al crear ALTA');
      }
    } catch (err) {
      console.error('Error creando ALTA:', err);
      setError('Error al crear ALTA');
    } finally {
      setLoading(false);
    }
  };

  const resetAltaForm = () => {
    setPasoAlta(1);
    setSalarioMode('mensual');
    setAltaData({
      prealta_id: '',
      prealtaDetails: null,
      id_empleado: '',
      curp: '',
      rfc: '',
      sucursal_final: '',
      ubicacion_final: '',
      centro_final: '',
      nodo_final: '',
      domicilio: {},
      nodo_id: '',
      puesto_final: '',
      area_final: '',
      salario_base: '',
      salario_diario: '',
      fecha_ingreso: new Date().toISOString().split('T')[0],
      agencia_id: '',
      garantiaTerms: null,
      bonusTerms: null,
      recomendador_id: '',
      valesDespensa: '600'
    });
    setAltaFormErrors({});
    setAltaSuccessData(null);
    setAltaConfirmGarantia(false);
    setAltaConfirmBonus(false);
  };

  const aplicarFiltros = () => {
    let filtered = [...prealtasData];

    if (filtros.estado) {
      filtered = filtered.filter(p => p.estado_prealta === filtros.estado);
    }
    if (filtros.fuente) {
      filtered = filtered.filter(p => p.fuente_reclutamiento === filtros.fuente);
    }
    if (filtros.puesto) {
      filtered = filtered.filter(p =>
        p.puesto_previsto.toLowerCase().includes(filtros.puesto.toLowerCase())
      );
    }

    // Ordenar
    filtered.sort((a, b) => {
      let aVal = a[sortConfig.key];
      let bVal = b[sortConfig.key];

      if (typeof aVal === 'string') {
        aVal = aVal.toLowerCase();
        bVal = bVal.toLowerCase();
      }

      if (sortConfig.direction === 'asc') {
        return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
      } else {
        return aVal > bVal ? -1 : aVal < bVal ? 1 : 0;
      }
    });

    return filtered;
  };

  const cambiarOrdenamiento = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const getPuestosUnicos = () => {
    const puestos = new Set(prealtasData.map(p => p.puesto_previsto));
    return Array.from(puestos).sort();
  };

  const getEstadoBadgeColor = (estado) => {
    const colores = {
      'Nuevo': '#6366f1',
      'Entrevistado': '#3b82f6',
      'En revisión': '#f59e0b',
      'Programado a ingreso': '#10b981',
      'Rechazado': '#ef4444',
      'No se presentó': '#8b5cf6',
      'Espera aviso': '#6b7280',
      'En negociación': '#ec4899'
    };
    return colores[estado] || '#6b7280';
  };

  // ============= GARANTIAS TAB FUNCTIONS =============

  // Garantías Sub-Tab
  const cargarGarantias = async () => {
    try {
      setLoading(true);
      const response = await fetch(API_URL + '?path=api/reclutamiento/reporte-garantias-agencia');
      const data = await response.json();
      setGarantiaData(data.data || []);
    } catch (err) {
      console.error('Error cargando Garantías:', err);
      setError('Error al cargar Garantías');
    } finally {
      setLoading(false);
    }
  };

  const calcularDiasRestantes = (fecha_vencimiento) => {
    const hoy = new Date();
    const vencimiento = new Date(fecha_vencimiento);
    const diff = vencimiento.getTime() - hoy.getTime();
    const dias = Math.ceil(diff / (1000 * 60 * 60 * 24));
    return dias;
  };

  const getEstadoGarantia = (dias_restantes) => {
    if (dias_restantes < 0) return 'Vencida';
    if (dias_restantes <= 5) return 'Próxima a Vencer';
    return 'Vigente';
  };

  const getColorEstadoGarantia = (dias_restantes) => {
    const estado = getEstadoGarantia(dias_restantes);
    if (estado === 'Vigente') return '#10b981';
    if (estado === 'Próxima a Vencer') return '#f59e0b';
    return '#ef4444';
  };

  const filtrarGarantias = () => {
    let filtered = [...garantiasData].filter(g => g.estado_empleado === 'Activo');

    if (filtroGarantia.agencia) {
      filtered = filtered.filter(g => g.agencia === filtroGarantia.agencia);
    }
    if (filtroGarantia.estado) {
      filtered = filtered.filter(g => {
        const dias = calcularDiasRestantes(g.fecha_vencimiento);
        return getEstadoGarantia(dias) === filtroGarantia.estado;
      });
    }

    return filtered;
  };

  const calcularResumenGarantias = () => {
    const filtered = filtrarGarantias();
    let vigentes = 0, proximas = 0, vencidas = 0, costoTotal = 0;

    filtered.forEach(g => {
      const dias = calcularDiasRestantes(g.fecha_vencimiento);
      const estado = getEstadoGarantia(dias);
      costoTotal += g.costo_ingreso || 0;

      if (estado === 'Vigente') vigentes++;
      else if (estado === 'Próxima a Vencer') proximas++;
      else vencidas++;
    });

    return { vigentes, proximas, vencidas, costoTotal };
  };

  // Bonos Sub-Tab
  const cargarBonos = async () => {
    try {
      setLoading(true);
      const response = await fetch(API_URL + '?path=api/reclutamiento/listar-bonos');
      const data = await response.json();
      setBonosData(data.data || []);
    } catch (err) {
      console.error('Error cargando Bonos:', err);
      setError('Error al cargar Bonos');
    } finally {
      setLoading(false);
    }
  };

  const filtrarBonos = () => {
    let filtered = [...bonosData];

    if (filtroBono.estado_primer) {
      filtered = filtered.filter(b => b.estado_primer_pago === filtroBono.estado_primer);
    }
    if (filtroBono.estado_segundo) {
      filtered = filtered.filter(b => b.estado_segundo_pago === filtroBono.estado_segundo);
    }

    return filtered;
  };

  const calcularResumenBonos = () => {
    let bonosPendientes = 0, totalPendiente = 0, pagadosEsteMes = 0;

    bonosData.forEach(b => {
      if (b.estado_primer_pago === 'Pendiente') {
        bonosPendientes++;
        totalPendiente += b.monto_primer_pago;
      }
      if (b.estado_segundo_pago === 'Pendiente') {
        bonosPendientes++;
        totalPendiente += b.monto_segundo_pago;
      }
      if (b.estado_primer_pago === 'Pagado' || b.estado_segundo_pago === 'Pagado') {
        pagadosEsteMes++;
      }
    });

    return { bonosPendientes, totalPendiente, pagadosEsteMes };
  };

  const puedepagarSegundoPago = (fecha_ingreso) => {
    const hoy = new Date();
    const ingreso = new Date(fecha_ingreso);
    const diff = hoy.getTime() - ingreso.getTime();
    const diasTranscurridos = Math.floor(diff / (1000 * 60 * 60 * 24));
    return diasTranscurridos >= 90;
  };

  const procesarPagoBono = async (bono_id, pago_numero) => {
    try {
      setLoadingBono(true);
      const response = await fetch(API_URL + '?path=api/reclutamiento/procesar-bono-referencia', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bono_id, accion: 'APROBAR', pago_numero })
      });
      const result = await response.json();

      if (result.success) {
        setBonosData(prev => prev.map(b => {
          if (b.id_bono === bono_id) {
            if (pago_numero === 1) {
              return { ...b, estado_primer_pago: 'Pagado' };
            } else {
              return { ...b, estado_segundo_pago: 'Pagado' };
            }
          }
          return b;
        }));

        setSuccessMessage(`Pago registrado exitosamente - Bono ${bono_id}`);
        setTimeout(() => setSuccessMessage(''), 3000);
        setShowConfirmPago(null);
      } else {
        setError(result.error || 'Error al procesar pago');
      }
    } catch (err) {
      console.error('Error procesando pago:', err);
      setError('Error al procesar pago');
    } finally {
      setLoadingBono(false);
    }
  };

  const cargarReporte = async () => {
    try {
      setLoading(true);

      let endpoint = '';
      if (reporteType === 'garantias') {
        endpoint = 'api/reclutamiento/reporte-garantias-agencia';
      } else if (reporteType === 'gastos') {
        endpoint = 'api/reclutamiento/reporte-gastos-totales';
      } else if (reporteType === 'avanza') {
        endpoint = 'api/reclutamiento/reporte-control-avanza';
      }

      const response = await fetch(API_URL + `?path=${endpoint}`);
      const data = await response.json();

      setReporteData({
        tipo: reporteType,
        datos: data.data || []
      });
    } catch (err) {
      console.error('Error cargando reporte:', err);
      setError('Error al cargar reporte');
    } finally {
      setLoading(false);
    }
  };

  const exportarReporte = (formato) => {
    // Placeholder for export functionality
    console.log(`Exportando reporte como ${formato}`);
  };

  // ============= CONTROL AVANZA FUNCTIONS =============

  const calcularKmRecorridos = (kmInicio, kmFin) => {
    const km_inicio = parseFloat(kmInicio) || 0;
    const km_fin = parseFloat(kmFin) || 0;
    return Math.abs(km_fin - km_inicio);
  };

  const calcularCostoTotal = (kmRecorridos, costoKm, viaticos, diesel, otros) => {
    const costo_km = parseFloat(costoKm) || 10;
    const via = parseFloat(viaticos) || 0;
    const die = parseFloat(diesel) || 0;
    const otr = parseFloat(otros) || 0;
    return (kmRecorridos * costo_km) + via + die + otr;
  };

  useEffect(() => {
    // Actualizar cálculos cuando cambian los valores relevantes
    const kmRec = calcularKmRecorridos(formControl.km_inicio, formControl.km_fin);
    const costTotal = calcularCostoTotal(
      kmRec,
      formControl.costo_km,
      formControl.gastos_viaticos,
      formControl.gastos_diesel,
      formControl.gastos_otros
    );
    setCalculosControl({
      km_recorridos: kmRec,
      costo_total_dia: costTotal
    });
  }, [formControl.km_inicio, formControl.km_fin, formControl.costo_km, formControl.gastos_viaticos, formControl.gastos_diesel, formControl.gastos_otros]);

  const cargarControlesAvanza = async () => {
    try {
      setLoading(true);
      const response = await fetch(API_URL + '?path=api/reclutamiento/listar-control-avanza');
      const data = await response.json();
      setControlData(data.data || []);
    } catch (err) {
      console.error('Error cargando controles AVANZA:', err);
      setError('Error al cargar controles');
    } finally {
      setLoading(false);
    }
  };

  const validarFormControl = () => {
    const errors = {};

    if (!formControl.quien_salio.trim()) errors.quien_salio = 'Requerido';
    if (!formControl.fecha) errors.fecha = 'Requerido';
    if (!formControl.horario_salida) errors.horario_salida = 'Requerido';
    if (!formControl.horario_entrada) errors.horario_entrada = 'Requerido';
    if (!formControl.km_inicio) errors.km_inicio = 'Requerido';
    if (!formControl.km_fin) errors.km_fin = 'Requerido';
    if (!formControl.donde_fue.trim()) errors.donde_fue = 'Requerido';
    if (!formControl.prospectos_contactados) errors.prospectos_contactados = 'Requerido';
    if (!formControl.volantes_repartidos) errors.volantes_repartidos = 'Requerido';
    if (!formControl.resultados_notas.trim()) errors.resultados_notas = 'Requerido';

    setFormControlErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const guardarControlAvanza = async () => {
    if (!validarFormControl()) return;

    try {
      setLoading(true);
      const payload = {
        quien_salio: formControl.quien_salio,
        fecha: formControl.fecha,
        horario_salida: formControl.horario_salida,
        horario_entrada: formControl.horario_entrada,
        km_inicio: parseFloat(formControl.km_inicio),
        km_fin: parseFloat(formControl.km_fin),
        costo_km: parseFloat(formControl.costo_km),
        donde_fue: formControl.donde_fue,
        prospectos_contactados: parseInt(formControl.prospectos_contactados),
        volantes_repartidos: parseInt(formControl.volantes_repartidos),
        gastos_viaticos: parseFloat(formControl.gastos_viaticos) || 0,
        gastos_diesel: parseFloat(formControl.gastos_diesel) || 0,
        gastos_otros: parseFloat(formControl.gastos_otros) || 0,
        resultados_notas: formControl.resultados_notas,
        notas: formControl.notas
      };

      const response = await fetch(API_URL + '?path=api/reclutamiento/registrar-control-avanza', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await response.json();

      if (result.success || result.id_control) {
        const gastosCantidad = (payload.gastos_viaticos > 0 ? 1 : 0) + (payload.gastos_diesel > 0 ? 1 : 0) + (payload.gastos_otros > 0 ? 1 : 0) + 1;
        setSuccessMessage(`Control AVANZA ${result.id_control} registrado exitosamente. Gastos autogenerados: ${gastosCantidad} registros.`);

        resetFormControl();
        setShowFormControlModal(false);
        await cargarControlesAvanza();

        setTimeout(() => setSuccessMessage(''), 4000);
      } else {
        setError(result.error || 'Error al guardar control');
      }
    } catch (err) {
      console.error('Error guardando control:', err);
      setError('Error al guardar control');
    } finally {
      setLoading(false);
    }
  };

  const resetFormControl = () => {
    setFormControl({
      quien_salio: '',
      fecha: new Date().toISOString().split('T')[0],
      horario_salida: '',
      horario_entrada: '',
      km_inicio: '',
      km_fin: '',
      costo_km: 10,
      donde_fue: '',
      prospectos_contactados: '',
      volantes_repartidos: '',
      gastos_viaticos: 0,
      gastos_diesel: 0,
      gastos_otros: 0,
      resultados_notas: '',
      notas: ''
    });
    setFormControlErrors({});
  };

  const cambiarFormControl = (field, value) => {
    setFormControl(prev => ({ ...prev, [field]: value }));
    if (formControlErrors[field]) {
      setFormControlErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const filtrarControles = () => {
    let filtered = [...controlData];

    if (filtroControl.agente) {
      filtered = filtered.filter(c => c.quien_salio === filtroControl.agente);
    }

    // Ordenar
    filtered.sort((a, b) => {
      let aVal = a[sortControl.key];
      let bVal = b[sortControl.key];

      if (typeof aVal === 'string') {
        aVal = aVal.toLowerCase();
        bVal = bVal.toLowerCase();
      }

      if (sortControl.direction === 'asc') {
        return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
      } else {
        return aVal > bVal ? -1 : aVal < bVal ? 1 : 0;
      }
    });

    return filtered;
  };

  const cambiarOrdenamientoControl = (key) => {
    setSortControl(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const calcularResumenMes = () => {
    const ahora = new Date();
    const mesActual = ahora.getMonth();
    const anoActual = ahora.getFullYear();

    const controlesMes = controlData.filter(c => {
      const fechaControl = new Date(c.fecha);
      return fechaControl.getMonth() === mesActual && fechaControl.getFullYear() === anoActual;
    });

    let totalSalidas = controlesMes.length;
    let totalKm = 0;
    let totalCosto = 0;
    let totalProspectos = 0;
    let totalVolantes = 0;
    let totalViaticos = 0;
    let totalDiesel = 0;

    controlesMes.forEach(c => {
      totalKm += c.km_recorridos || 0;
      totalCosto += c.costo_total_dia || 0;
      totalProspectos += c.prospectos_contactados || 0;
      totalVolantes += c.volantes_repartidos || 0;
      totalViaticos += c.gastos_viaticos || 0;
      totalDiesel += c.gastos_diesel || 0;
    });

    return {
      totalSalidas,
      totalKm,
      totalCosto,
      totalProspectos,
      totalVolantes,
      totalViaticos,
      totalDiesel,
      mes: ahora.toLocaleDateString('es-MX', { month: 'long', year: 'numeric' }).charAt(0).toUpperCase() + ahora.toLocaleDateString('es-MX', { month: 'long', year: 'numeric' }).slice(1)
    };
  };

  const getAgentesUnicos = () => {
    const agentes = new Set(controlData.map(c => c.quien_salio));
    return Array.from(agentes).sort();
  };

  const getDiaSemana = (fecha) => {
    const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const date = new Date(fecha + 'T00:00:00');
    return diasSemana[date.getDay()];
  };

  const toggleExpandedRow = (id) => {
    const newExpanded = new Set(expandedRows);
    if (newExpanded.has(id)) {
      newExpanded.delete(id);
    } else {
      newExpanded.add(id);
    }
    setExpandedRows(newExpanded);
  };

  return (
    <div>
      {/* Header */}
      <div className="page-header">
        <div className="page-title"><i className="ti ti-briefcase"></i> Reclutamiento</div>
        <div className="page-subtitle">Gestión de vacantes, candidatos, contrataciones y control operacional</div>
      </div>

      {/* Error Alert */}
      {error && (
        <div className="card" style={{ background: '#fef2f2', borderLeft: '4px solid #dc2626', marginBottom: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#991b1b' }}>
            <i className="ti ti-alert-circle"></i>
            <div>
              <div style={{ fontWeight: 600, fontSize: '14px' }}>Error al cargar datos</div>
              <div style={{ fontSize: '13px', marginTop: '4px' }}>{error}</div>
            </div>
          </div>
        </div>
      )}

      {/* Tabs Navigation - Comedor Style */}
      <div className="tabs-nav" style={{ marginTop: '24px', marginBottom: '24px' }}>
        <button
          className={`tab-btn ${activeTab === 'dashboard' ? 'active' : ''}`}
          onClick={() => setActiveTab('dashboard')}
        >
          <i className="ti ti-layout-dashboard"></i>
          <span>Dashboard</span>
        </button>
        <button
          className={`tab-btn ${activeTab === 'pre-altas' ? 'active' : ''}`}
          onClick={() => setActiveTab('pre-altas')}
        >
          <i className="ti ti-users"></i>
          <span>Control de Entrevistas</span>
        </button>
        <button
          className={`tab-btn ${activeTab === 'procesar-alta' ? 'active' : ''}`}
          onClick={() => setActiveTab('procesar-alta')}
        >
          <i className="ti ti-briefcase"></i>
          <span>Procesar Alta</span>
        </button>
        {/* Documentos tab - Temporarily disabled
        <button
          className={`tab-btn ${activeTab === 'documentos' ? 'active' : ''}`}
          onClick={() => setActiveTab('documentos')}
        >
          <i className="ti ti-files"></i>
          <span>Documentos</span>
        </button>
        */}
        <button
          className={`tab-btn ${activeTab === 'garantias' ? 'active' : ''}`}
          onClick={() => setActiveTab('garantias')}
        >
          <i className="ti ti-shield"></i>
          <span>Garantías</span>
        </button>
        <button
          className={`tab-btn ${activeTab === 'control-avanza' ? 'active' : ''}`}
          onClick={() => setActiveTab('control-avanza')}
        >
          <i className="ti ti-truck"></i>
          <span>Control de gastos</span>
        </button>
      </div>

      {/* Tab Contents */}
      <div className="tabs-content">
        {/* Dashboard Tab */}
        {activeTab === 'dashboard' && (
          <div>
            {/* KPI Cards Grid - Modern Design */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginBottom: '32px' }}>
              {/* 1. Vacantes Abiertas - Teal */}
              <div
                style={{
                  background: 'linear-gradient(135deg, #0086ab 0%, #00a8cc 100%)',
                  borderRadius: '16px',
                  padding: '24px',
                  cursor: 'default',
                  transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: '0 4px 12px rgba(0, 134, 171, 0.25)',
                  position: 'relative',
                  overflow: 'hidden',
                  minHeight: '140px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 12px 28px rgba(0, 134, 171, 0.35)';
                  e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 134, 171, 0.25)';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                }}
              >
                <div style={{ position: 'absolute', top: '-20px', right: '-20px', fontSize: '80px', opacity: 0.1 }}>
                  <i className="ti ti-clipboard-list"></i>
                </div>
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.85)', fontWeight: 500 }}>Vacantes Abiertas</div>
                    <i className="ti ti-clipboard-list" style={{ fontSize: '32px', color: 'white' }}></i>
                  </div>
                  <div style={{ fontSize: '36px', fontWeight: 800, color: 'white', marginBottom: '8px' }}>{kpis.vacantesAbiertas}</div>
                  <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <span>Posiciones disponibles</span>
                  </div>
                </div>
              </div>

              {/* 2. Control de Entrevistas - Purple */}
              <div
                style={{
                  background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
                  borderRadius: '16px',
                  padding: '24px',
                  cursor: 'default',
                  transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: '0 4px 12px rgba(124, 58, 237, 0.25)',
                  position: 'relative',
                  overflow: 'hidden',
                  minHeight: '140px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 12px 28px rgba(124, 58, 237, 0.35)';
                  e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(124, 58, 237, 0.25)';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                }}
              >
                <div style={{ position: 'absolute', top: '-20px', right: '-20px', fontSize: '80px', opacity: 0.1 }}>
                  <i className="ti ti-users-group"></i>
                </div>
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.85)', fontWeight: 500 }}>Control de Entrevistas</div>
                    <i className="ti ti-users-group" style={{ fontSize: '32px', color: 'white' }}></i>
                  </div>
                  <div style={{ fontSize: '36px', fontWeight: 800, color: 'white', marginBottom: '8px' }}>{kpis.preAltas}</div>
                  <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)' }}>Candidatos activos</div>
                </div>
              </div>

              {/* 3. Ingresos Este Mes - Green */}
              <div
                style={{
                  background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
                  borderRadius: '16px',
                  padding: '24px',
                  cursor: 'default',
                  transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: '0 4px 12px rgba(5, 150, 105, 0.25)',
                  position: 'relative',
                  overflow: 'hidden',
                  minHeight: '140px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 12px 28px rgba(5, 150, 105, 0.35)';
                  e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(5, 150, 105, 0.25)';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                }}
              >
                <div style={{ position: 'absolute', top: '-20px', right: '-20px', fontSize: '80px', opacity: 0.1 }}>
                  <i className="ti ti-briefcase"></i>
                </div>
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.85)', fontWeight: 500 }}>Ingresos Este Mes</div>
                    <i className="ti ti-briefcase" style={{ fontSize: '32px', color: 'white' }}></i>
                  </div>
                  <div style={{ fontSize: '36px', fontWeight: 800, color: 'white', marginBottom: '8px' }}>{kpis.ingresosEsteMes}</div>
                  <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)' }}>Nuevos empleados</div>
                </div>
              </div>

              {/* 4. Bonos Pendientes - Amber */}
              <div
                style={{
                  background: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
                  borderRadius: '16px',
                  padding: '24px',
                  cursor: 'default',
                  transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: '0 4px 12px rgba(245, 158, 11, 0.25)',
                  position: 'relative',
                  overflow: 'hidden',
                  minHeight: '140px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 12px 28px rgba(245, 158, 11, 0.35)';
                  e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(245, 158, 11, 0.25)';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                }}
              >
                <div style={{ position: 'absolute', top: '-20px', right: '-20px', fontSize: '80px', opacity: 0.1 }}>
                  <i className="ti ti-coin"></i>
                </div>
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.85)', fontWeight: 500 }}>Bonos Pendientes</div>
                    <i className="ti ti-coin" style={{ fontSize: '32px', color: 'white' }}></i>
                  </div>
                  <div style={{ fontSize: '32px', fontWeight: 800, color: 'white', marginBottom: '8px', fontFamily: 'monospace' }}>{formatCurrencyMX(kpis.bonosPendientes)}</div>
                  <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)' }}>Monto a procesar</div>
                </div>
              </div>

              {/* 5. Costo Agencias - Red */}
              <div
                style={{
                  background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
                  borderRadius: '16px',
                  padding: '24px',
                  cursor: 'default',
                  transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: '0 4px 12px rgba(220, 38, 38, 0.25)',
                  position: 'relative',
                  overflow: 'hidden',
                  minHeight: '140px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 12px 28px rgba(220, 38, 38, 0.35)';
                  e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(220, 38, 38, 0.25)';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                }}
              >
                <div style={{ position: 'absolute', top: '-20px', right: '-20px', fontSize: '80px', opacity: 0.1 }}>
                  <i className="ti ti-building-warehouse"></i>
                </div>
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.85)', fontWeight: 500 }}>Costo Agencias</div>
                    <i className="ti ti-building-warehouse" style={{ fontSize: '32px', color: 'white' }}></i>
                  </div>
                  <div style={{ fontSize: '32px', fontWeight: 800, color: 'white', marginBottom: '8px', fontFamily: 'monospace' }}>{formatCurrencyMX(kpis.costoAgencias)}</div>
                  <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)' }}>Inversión en recursos</div>
                </div>
              </div>

              {/* 6. Costo Interno - Orange */}
              <div
                style={{
                  background: 'linear-gradient(135deg, #ea580c 0%, #fb923c 100%)',
                  borderRadius: '16px',
                  padding: '24px',
                  cursor: 'default',
                  transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: '0 4px 12px rgba(234, 88, 12, 0.25)',
                  position: 'relative',
                  overflow: 'hidden',
                  minHeight: '140px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 12px 28px rgba(234, 88, 12, 0.35)';
                  e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(234, 88, 12, 0.25)';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                }}
              >
                <div style={{ position: 'absolute', top: '-20px', right: '-20px', fontSize: '80px', opacity: 0.1 }}>
                  <i className="ti ti-chart-dots"></i>
                </div>
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.85)', fontWeight: 500 }}>Costo Interno</div>
                    <i className="ti ti-chart-dots" style={{ fontSize: '32px', color: 'white' }}></i>
                  </div>
                  <div style={{ fontSize: '32px', fontWeight: 800, color: 'white', marginBottom: '8px', fontFamily: 'monospace' }}>{formatCurrencyMX(kpis.costoInterno)}</div>
                  <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)' }}>Gastos operacionales</div>
                </div>
              </div>

              {/* 7. KM Avanza - Violet */}
              <div
                style={{
                  background: 'linear-gradient(135deg, #8b5cf6 0%, #c4b5fd 100%)',
                  borderRadius: '16px',
                  padding: '24px',
                  cursor: 'default',
                  transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: '0 4px 12px rgba(139, 92, 246, 0.25)',
                  position: 'relative',
                  overflow: 'hidden',
                  minHeight: '140px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 12px 28px rgba(139, 92, 246, 0.35)';
                  e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 92, 246, 0.25)';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                }}
              >
                <div style={{ position: 'absolute', top: '-20px', right: '-20px', fontSize: '80px', opacity: 0.1 }}>
                  <i className="ti ti-route"></i>
                </div>
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.85)', fontWeight: 500 }}>KM Avanza</div>
                    <i className="ti ti-route" style={{ fontSize: '32px', color: 'white' }}></i>
                  </div>
                  <div style={{ fontSize: '36px', fontWeight: 800, color: 'white', marginBottom: '8px' }}>{kpis.kmAvanza}</div>
                  <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)' }}>Kilómetros recorridos</div>
                </div>
              </div>

              {/* 8. Tasa Conversión - Cyan */}
              <div
                style={{
                  background: 'linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)',
                  borderRadius: '16px',
                  padding: '24px',
                  cursor: 'default',
                  transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: '0 4px 12px rgba(8, 145, 178, 0.25)',
                  position: 'relative',
                  overflow: 'hidden',
                  minHeight: '140px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 12px 28px rgba(8, 145, 178, 0.35)';
                  e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(8, 145, 178, 0.25)';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                }}
              >
                <div style={{ position: 'absolute', top: '-20px', right: '-20px', fontSize: '80px', opacity: 0.1 }}>
                  <i className="ti ti-trending-up"></i>
                </div>
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.85)', fontWeight: 500 }}>Tasa Conversión</div>
                    <i className="ti ti-trending-up" style={{ fontSize: '32px', color: 'white' }}></i>
                  </div>
                  <div style={{ fontSize: '36px', fontWeight: 800, color: 'white', marginBottom: '8px' }}>{calcularTasaConversion()}%</div>
                  <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)' }}>Eficiencia de proceso</div>
                </div>
              </div>
            </div>

            {/* Resumen del Mes - Always Visible */}
            <div style={{ marginBottom: '24px' }}>
              {/* Section Header */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '12px 0',
                fontSize: '14px',
                fontWeight: 700,
                color: '#0086ab',
                marginBottom: '16px',
                borderBottom: '2px solid #0086ab'
              }}>
                <i className="ti ti-alert-circle"></i>
                <span>Resumen del Mes</span>
              </div>

              {/* Alerts Grid - Always visible */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
                gap: '16px'
              }}>
                {/* Alert Card 1: Vacantes sin candidatos */}
                <div style={{
                  background: 'linear-gradient(135deg, rgba(220,38,38,0.08) 0%, rgba(220,38,38,0.04) 100%)',
                  border: '1.5px solid #fca5a5',
                  borderRadius: '12px',
                  padding: '16px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(220, 38, 38, 0.2)';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.borderColor = '#ef4444';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = '#fca5a5';
                }}
                onClick={() => setActiveTab('pre-altas')}
                >
                  <i className="ti ti-alert-circle" style={{ fontSize: '28px', color: '#dc2626' }}></i>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', color: '#7f1d1d', fontWeight: 700 }}>
                      {kpis.vacantesAbiertas} Vacantes sin candidatos
                    </div>
                    <div style={{ fontSize: '11px', color: '#991b1b', marginTop: '2px' }}>
                      Requieren atención inmediata
                    </div>
                  </div>
                </div>

                {/* Alert Card 2: Candidatos sin entrevista */}
                <div style={{
                  background: 'linear-gradient(135deg, rgba(245,158,11,0.08) 0%, rgba(245,158,11,0.04) 100%)',
                  border: '1.5px solid #fdba74',
                  borderRadius: '12px',
                  padding: '16px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(245, 158, 11, 0.2)';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.borderColor = '#f59e0b';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = '#fdba74';
                }}
                onClick={() => setActiveTab('pre-altas')}
                >
                  <i className="ti ti-bell" style={{ fontSize: '28px', color: '#f59e0b' }}></i>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', color: '#78350f', fontWeight: 700 }}>
                      {kpis.preAltas - kpis.ingresosEsteMes} Candidatos sin entrevista
                    </div>
                    <div style={{ fontSize: '11px', color: '#92400e', marginTop: '2px' }}>
                      Pendientes de programación
                    </div>
                  </div>
                </div>

                {/* Alert Card 3: Garantías próximas a vencer */}
                <div style={{
                  background: 'linear-gradient(135deg, rgba(236,72,153,0.08) 0%, rgba(236,72,153,0.04) 100%)',
                  border: '1.5px solid #fbcfe8',
                  borderRadius: '12px',
                  padding: '16px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(236, 72, 153, 0.2)';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.borderColor = '#ec4899';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = '#fbcfe8';
                }}
                onClick={() => setActiveTab('garantias')}
                >
                  <div style={{ fontSize: '28px', lineHeight: '1' }}>📅</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', color: '#831843', fontWeight: 700 }}>
                      {(() => {
                        let proximasAVencer = 0;
                        (garantiasData || []).forEach(g => {
                          const hoy = new Date();
                          const vencimiento = new Date(g.fecha_vencimiento);
                          const diff = vencimiento.getTime() - hoy.getTime();
                          const dias = Math.ceil(diff / (1000 * 60 * 60 * 24));
                          if (dias >= 0 && dias <= 5) proximasAVencer++;
                        });
                        return proximasAVencer;
                      })()} Garantías próximas a vencer
                    </div>
                    <div style={{ fontSize: '11px', color: '#be185d', marginTop: '2px' }}>
                      Revisión urgente en 5 días
                    </div>
                  </div>
                </div>

                {/* Alert Card 4: Bonos por pagar */}
                <div style={{
                  background: 'linear-gradient(135deg, rgba(59,130,246,0.08) 0%, rgba(59,130,246,0.04) 100%)',
                  border: '1.5px solid #bfdbfe',
                  borderRadius: '12px',
                  padding: '16px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(59, 130, 246, 0.2)';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.borderColor = '#3b82f6';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = '#bfdbfe';
                }}
                onClick={() => setActiveTab('garantias')}
                >
                  <div style={{ fontSize: '28px', lineHeight: '1' }}>💵</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', color: '#1e40af', fontWeight: 700 }}>
                      {formatCurrencyMX(kpis.bonosPendientes)} en bonos
                    </div>
                    <div style={{ fontSize: '11px', color: '#1e3a8a', marginTop: '2px' }}>
                      Pendiente de procesamiento
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Info Section */}
            <div className="card">
              <div className="card-title">
                <i className="ti ti-info-circle"></i>
                Información Útil
              </div>
              <div style={{ fontSize: '13px', color: '#6b7280', lineHeight: '1.6' }}>
                <p style={{ margin: '0 0 8px 0' }}>
                  Este dashboard proporciona una vista rápida de las actividades críticas y pendientes.
                </p>
                <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
                  <li>Haz clic en cualquier alerta para ir a la sección correspondiente</li>
                  <li>Los números se actualizan automáticamente según los datos en cada módulo</li>
                  <li>Prioriza las vacantes sin candidatos y las garantías próximas a vencer</li>
                </ul>
              </div>
            </div>
          </div>
        )}

        {/* PRE-ALTAS Tab */}
        {activeTab === 'pre-altas' && (
          <div>
            {/* Success Message */}
            {successMessage && (
              <div style={{
                background: '#d1fae5',
                border: '1px solid #6ee7b7',
                borderRadius: '8px',
                padding: '12px 16px',
                marginBottom: '16px',
                color: '#065f46',
                fontSize: '13px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <i className="ti ti-check"></i>
                {successMessage}
              </div>
            )}

            {/* Form Section */}
            <div className="card" style={{ marginBottom: '24px' }}>
              <div className="card-title">
                <i className="ti ti-plus"></i>
                Registrar Nuevo Candidato (Paso {paso} de 4)
              </div>

              {/* Progress Bar */}
              <div style={{ marginBottom: '20px' }}>
                <div style={{
                  display: 'flex',
                  gap: '8px',
                  marginBottom: '12px'
                }}>
                  {[1, 2, 3, 4].map(p => (
                    <div
                      key={p}
                      style={{
                        flex: 1,
                        height: '4px',
                        background: p <= paso ? '#0086ab' : '#e5e7eb',
                        borderRadius: '2px',
                        transition: 'all 0.3s'
                      }}
                    />
                  ))}
                </div>
              </div>

              {/* Step 1: Basic Information */}
              {paso === 1 && (
                <div>
                  <SeccionLabel icon="ti-user">Datos Personales</SeccionLabel>
                  <div className="form-grid">
                    <div>
                      <Input
                        label="Apellido Paterno *"
                        name="apellido_paterno"
                        value={formData.apellido_paterno}
                        onChange={(e) => cambiarFormData('apellido_paterno', e.target.value)}
                      />
                      {formErrors.apellido_paterno && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formErrors.apellido_paterno}</span>}
                    </div>
                    <div>
                      <Input
                        label="Apellido Materno *"
                        name="apellido_materno"
                        value={formData.apellido_materno}
                        onChange={(e) => cambiarFormData('apellido_materno', e.target.value)}
                      />
                      {formErrors.apellido_materno && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formErrors.apellido_materno}</span>}
                    </div>
                    <div>
                      <Input
                        label="Nombres *"
                        name="nombres"
                        value={formData.nombres}
                        onChange={(e) => cambiarFormData('nombres', e.target.value)}
                      />
                      {formErrors.nombres && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formErrors.nombres}</span>}
                    </div>
                    <div>
                      <Input
                        label="Teléfono *"
                        name="telefono"
                        type="tel"
                        value={formData.telefono}
                        onChange={(e) => cambiarFormData('telefono', e.target.value)}
                      />
                      {formErrors.telefono && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formErrors.telefono}</span>}
                    </div>
                    <div style={{ gridColumn: '1 / -1' }}>
                      <Input
                        label="Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={(e) => cambiarFormData('email', e.target.value)}
                      />
                      {formErrors.email && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formErrors.email}</span>}
                    </div>
                    <div>
                      <Select
                        label="Sucursal *"
                        name="sucursal"
                        value={formData.sucursal}
                        onChange={(e) => {
                          cambiarFormData('sucursal', e.target.value);
                          cambiarFormData('ubicacion_fisica', '');
                          cambiarFormData('centro_costos', '');
                          cambiarFormData('nodo_id', '');
                          cambiarFormData('turno_id', '');
                        }}
                        opciones={[
                          { value: 'Apodaca', label: 'Apodaca' },
                          { value: 'Guadalajara', label: 'Guadalajara' },
                          { value: 'Mexico', label: 'Mexico' },
                          { value: 'Juárez', label: 'Juárez' },
                          { value: 'San Pedro', label: 'San Pedro' }
                        ]}
                      />
                    </div>
                    <div>
                      <Select
                        label="Ubicación Física *"
                        name="ubicacion_fisica"
                        value={formData.ubicacion_fisica}
                        onChange={(e) => {
                          cambiarFormData('ubicacion_fisica', e.target.value);
                          cambiarFormData('centro_costos', '');
                          cambiarFormData('nodo_id', '');
                          cambiarFormData('turno_id', '');
                        }}
                        opciones={obtenerUbicacionesPorSucursal(formData.sucursal).map(u => ({ value: u.ID_Ubicacion, label: u.Nombre_Ubicacion }))}
                        disabled={!formData.sucursal}
                      />
                    </div>
                    <div>
                      <Select
                        label="Centro de Costos *"
                        name="centro_costos"
                        value={formData.centro_costos}
                        onChange={(e) => {
                          cambiarFormData('centro_costos', e.target.value);
                          cambiarFormData('nodo_id', '');
                        }}
                        opciones={obtenerCentrosPorUbicacion(formData.ubicacion_fisica).map(c => ({ value: c.ID_Centro, label: c.Centro_Costos }))}
                        disabled={!formData.ubicacion_fisica}
                      />
                    </div>
                    <div>
                      <Select
                        label="Nodo/Vacante"
                        name="nodo_id"
                        value={formData.nodo_id}
                        onChange={async (e) => {
                          const nodoId = e.target.value;
                          cambiarFormData('nodo_id', nodoId);

                          // Obtener puesto recomendado del nodo
                          if (nodoId) {
                            try {
                              const response = await fetch(`${API_URL}?path=api/nodos/puesto-recomendado&nodo_id=${nodoId}`);
                              const data = await response.json();
                              if (data.success && data.puesto_recomendado) {
                                cambiarFormData('puesto_previsto', data.puesto_recomendado);
                              }
                            } catch (err) {
                              console.error('Error obteniendo puesto recomendado:', err);
                            }
                          }
                        }}
                        opciones={obtenerNodosPorCentro(formData.centro_costos).map(n => ({ value: n.Nodo_ID, label: n.Nombre_Nodo }))}
                        disabled={!formData.centro_costos}
                      />
                    </div>
                    <div>
                      <Select
                        label="Turno"
                        name="turno_id"
                        value={formData.turno_id}
                        onChange={(e) => cambiarFormData('turno_id', e.target.value)}
                        opciones={obtenerTurnosPorSucursal(formData.ubicacion_fisica).map(t => ({ value: t.ID_Turno, label: t.Nombre }))}
                        disabled={!formData.ubicacion_fisica}
                      />
                    </div>
                    <div>
                      <Select
                        label="Puesto Previsto *"
                        name="puesto_previsto"
                        value={formData.puesto_previsto}
                        onChange={(e) => cambiarFormData('puesto_previsto', e.target.value)}
                        opciones={puestosList.length > 0 ? puestosList.map(p => ({ value: p.Nombre, label: p.Nombre })) : ['Ingeniero Mecánico', 'Contador', 'Operario']}
                      />
                      {formErrors.puesto_previsto && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formErrors.puesto_previsto}</span>}
                    </div>
                  </div>
                </div>
              )}

              {/* Step 2: Interview Details */}
              {paso === 2 && (
                <div>
                  <SeccionLabel icon="ti-calendar-event">Detalles de Entrevista</SeccionLabel>
                  <div className="form-grid">
                    <Input
                      label="Fecha de Entrevista"
                      name="fecha_entrevista"
                      type="date"
                      value={formData.fecha_entrevista}
                      onChange={(e) => cambiarFormData('fecha_entrevista', e.target.value)}
                    />
                    <Input
                      label="Hora de Entrevista"
                      name="hora_entrevista"
                      type="time"
                      value={formData.hora_entrevista}
                      onChange={(e) => cambiarFormData('hora_entrevista', e.target.value)}
                    />
                    <Select
                      label="Entrevistador RH"
                      name="entrevistador_rh"
                      value={formData.entrevistador_rh}
                      onChange={(e) => cambiarFormData('entrevistador_rh', e.target.value)}
                      opciones={personalRHList.filter(p => p.Activo === 'Si').map(p => ({ value: p.ID_Personal, label: `${p.Nombre} (${p.Puesto})` }))}
                    />
                    <Select
                      label="Entrevistador Gerente"
                      name="entrevistador_gerente"
                      value={formData.entrevistador_gerente}
                      onChange={(e) => cambiarFormData('entrevistador_gerente', e.target.value)}
                      opciones={gerentesList.filter(g => g.Activo === 'Si').map(g => ({ value: g.ID_Gerente, label: `${g.Nombre} (${g.Puesto})` }))}
                    />
                    <div style={{ gridColumn: '1 / -1' }}>
                      <Input
                        label="Comentarios sobre la entrevista"
                        name="comentarios"
                        value={formData.comentarios}
                        onChange={(e) => cambiarFormData('comentarios', e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Step 3: Recommendation & Background */}
              {paso === 3 && (
                <div>
                  <SeccionLabel icon="ti-briefcase">Reclutamiento y Antecedentes</SeccionLabel>
                  <div className="form-grid">
                    <div>
                      <Select
                        label="Fuente de Reclutamiento *"
                        name="fuente_reclutamiento"
                        value={formData.fuente_reclutamiento}
                        onChange={(e) => cambiarFormData('fuente_reclutamiento', e.target.value)}
                        opciones={FUENTES_RECLUTAMIENTO}
                      />
                      {formErrors.fuente_reclutamiento && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formErrors.fuente_reclutamiento}</span>}
                    </div>
                    <SelectSearchable
                      label="Empleado Recomendador (Activos)"
                      name="recomendado_por_empleado_id"
                      value={formData.recomendado_por_empleado_id}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        cambiarFormData('recomendado_por_empleado_id', selectedId);
                        // Auto-fill nombre based on employee ID
                        const empleado = empleadosList.find(emp => String(emp.id) === String(selectedId));
                        if (empleado) {
                          cambiarFormData('recomendado_por_nombre', empleado.nombre || '');
                          console.log('✅ Auto-rellenado:', empleado.nombre);
                        }
                      }}
                      opciones={empleadosList
                        .filter(emp => emp.Estatus === 'Activo')
                        .map(emp => ({
                          value: emp.id,
                          label: `${emp.id} - ${emp.nombre}`
                        }))
                      }
                    />
                    <Input
                      label="Nombre Recomendador (Auto-rellenado)"
                      name="recomendado_por_nombre"
                      value={formData.recomendado_por_nombre}
                      disabled
                    />
                    <div style={{ marginBottom: '20px' }}>
                      <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '10px' }}>Documentos Verificados</label>
                      {[
                        { key: 'comprobante_domicilio', label: 'Comprobante de domicilio' },
                        { key: 'constancia_fiscal', label: 'Constancia fiscal actualizada' },
                        { key: 'comprobante_estudios', label: 'Comprobante de estudios' },
                        { key: 'seguro_social', label: 'Número de seguro social' },
                        { key: 'acta_nacimiento', label: 'Acta de nacimiento' },
                        { key: 'identificacion_ine', label: 'Identificación oficial (INE)' },
                        { key: 'curp', label: 'CURP' }
                      ].map(doc => (
                        <label key={doc.key} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', cursor: 'pointer' }}>
                          <input
                            type="checkbox"
                            checked={formData.documento_completo[doc.key] || false}
                            onChange={(e) => cambiarFormData('documento_completo', {
                              ...formData.documento_completo,
                              [doc.key]: e.target.checked
                            })}
                            style={{ marginRight: '10px', cursor: 'pointer' }}
                          />
                          {doc.label}
                        </label>
                      ))}
                    </div>
                    <Input
                      label="Años de Experiencia"
                      name="experiencia_anos"
                      type="number"
                      value={formData.experiencia_anos}
                      onChange={(e) => cambiarFormData('experiencia_anos', e.target.value)}
                    />
                    <Input
                      label="Disponibilidad de Inicio"
                      name="disponibilidad_inicio"
                      type="date"
                      value={formData.disponibilidad_inicio}
                      onChange={(e) => cambiarFormData('disponibilidad_inicio', e.target.value)}
                    />
                  </div>
                </div>
              )}

              {/* Step 4: Confirmation */}
              {paso === 4 && (
                <div>
                  <SeccionLabel icon="ti-circle-check">Resumen de Registro</SeccionLabel>
                  <div style={{ background: '#f3f4f6', padding: '16px', borderRadius: '8px', marginBottom: '16px' }}>
                    <p style={{ fontSize: '12px', color: '#6b7280', margin: '0 0 8px 0' }}>
                      <strong>Estado Inicial:</strong> Nuevo
                    </p>
                    <p style={{ fontSize: '12px', color: '#6b7280', margin: '0' }}>
                      <strong>Fecha de Registro:</strong> {new Date().toLocaleDateString('es-MX')}
                    </p>
                  </div>
                  <div className="info-grid">
                    <InfoCampo label="Nombre" valor={formData.nombre} />
                    <InfoCampo label="Email" valor={formData.email} />
                    <InfoCampo label="Teléfono" valor={formData.telefono} />
                    <InfoCampo label="Puesto" valor={formData.puesto_previsto} />
                    <InfoCampo label="Área" valor={formData.area_prevista} />
                    <InfoCampo label="Fuente" valor={formData.fuente_reclutamiento} />
                  </div>
                </div>
              )}

              {/* Navigation Buttons */}
              <div style={{
                display: 'flex',
                gap: '12px',
                marginTop: '24px',
                justifyContent: 'space-between'
              }}>
                <div>
                  {paso > 1 && (
                    <button
                      onClick={retrocederPaso}
                      style={{
                        padding: '8px 16px',
                        background: '#e5e7eb',
                        color: '#1f2937',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '12px',
                        fontWeight: 600,
                        cursor: 'pointer'
                      }}
                    >
                      <i className="ti ti-arrow-left" style={{ marginRight: '6px' }}></i>
                      Anterior
                    </button>
                  )}
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button
                    onClick={resetForm}
                    style={{
                      padding: '8px 16px',
                      background: '#f3f4f6',
                      color: '#6b7280',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '12px',
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}
                  >
                    Cancelar
                  </button>
                  {paso < 4 ? (
                    <button
                      onClick={avanzarPaso}
                      style={{
                        padding: '8px 16px',
                        background: '#0086ab',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '12px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}
                    >
                      Siguiente
                      <i className="ti ti-arrow-right"></i>
                    </button>
                  ) : (
                    <button
                      onClick={guardarPrealta}
                      disabled={loading}
                      style={{
                        padding: '8px 16px',
                        background: '#10b981',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '12px',
                        fontWeight: 600,
                        cursor: loading ? 'not-allowed' : 'pointer',
                        opacity: loading ? 0.6 : 1,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}
                    >
                      <i className="ti ti-device-floppy"></i>
                      Guardar
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Table Section */}
            <div className="card">
              <div className="card-title">
                <i className="ti ti-table"></i>
                Listado de Entrevistas
              </div>

              {/* Filters */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '12px',
                marginBottom: '16px',
                padding: '12px',
                background: '#f9fafb',
                borderRadius: '8px'
              }}>
                <Select
                  label="Filtrar por Estado"
                  name="filtro_estado"
                  value={filtros.estado}
                  onChange={(e) => setFiltros({ ...filtros, estado: e.target.value })}
                  opciones={['', ...ESTADOS_PREALTA]}
                />
                <Select
                  label="Filtrar por Fuente"
                  name="filtro_fuente"
                  value={filtros.fuente}
                  onChange={(e) => setFiltros({ ...filtros, fuente: e.target.value })}
                  opciones={['', ...FUENTES_RECLUTAMIENTO]}
                />
                <Select
                  label="Filtrar por Puesto"
                  name="filtro_puesto"
                  value={filtros.puesto}
                  onChange={(e) => setFiltros({ ...filtros, puesto: e.target.value })}
                  opciones={getPuestosUnicos()}
                />
              </div>

              {/* Table */}
              <div style={{ overflowX: 'auto' }}>
                <table className="tabla">
                  <thead>
                    <tr>
                      <th
                        className="sortable"
                        onClick={() => cambiarOrdenamiento('id_prealta')}
                        style={{ cursor: 'pointer' }}
                      >
                        ID {sortConfig.key === 'id_prealta' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
                      </th>
                      <th
                        className="sortable"
                        onClick={() => cambiarOrdenamiento('nombre')}
                        style={{ cursor: 'pointer' }}
                      >
                        Nombre {sortConfig.key === 'nombre' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
                      </th>
                      <th>Puesto</th>
                      <th>Fuente</th>
                      <th>Estado</th>
                      <th
                        className="sortable"
                        onClick={() => cambiarOrdenamiento('fecha_creacion')}
                        style={{ cursor: 'pointer' }}
                      >
                        Fecha {sortConfig.key === 'fecha_creacion' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
                      </th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {aplicarFiltros().map(prealta => (
                      <tr
                        key={prealta.id_prealta}
                        style={prealta.estado_prealta === 'Programado a ingreso' ? { background: '#eff6ff' } : {}}
                      >
                        <td style={{ fontWeight: 600, color: '#0086ab' }}>#{prealta.id_prealta}</td>
                        <td>{prealta.nombre}</td>
                        <td style={{ fontSize: '11px' }}>{prealta.puesto_previsto}</td>
                        <td style={{ fontSize: '11px' }}>{prealta.fuente_reclutamiento}</td>
                        <td>
                          <span
                            style={{
                              display: 'inline-block',
                              padding: '4px 10px',
                              borderRadius: '20px',
                              fontSize: '11px',
                              fontWeight: 600,
                              background: getEstadoBadgeColor(prealta.estado_prealta) + '20',
                              color: getEstadoBadgeColor(prealta.estado_prealta)
                            }}
                          >
                            {prealta.estado_prealta}
                          </span>
                        </td>
                        <td>{fmtFecha(prealta.fecha_creacion)}</td>
                        <td>
                          <button
                            onClick={() => setEditando(prealta)}
                            style={{
                              padding: '4px 8px',
                              background: '#3b82f6',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              fontSize: '11px',
                              cursor: 'pointer',
                              marginRight: '6px'
                            }}
                          >
                            <i className="ti ti-edit"></i> Editar
                          </button>
                          <button
                            onClick={() => setShowHistorial(prealta)}
                            style={{
                              padding: '4px 8px',
                              background: '#8b5cf6',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              fontSize: '11px',
                              cursor: 'pointer'
                            }}
                          >
                            <i className="ti ti-history"></i> Historial
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {aplicarFiltros().length === 0 && (
                  <div style={{
                    textAlign: 'center',
                    padding: '40px 20px',
                    color: '#6b7280',
                    fontSize: '13px'
                  }}>
                    <i className="ti ti-inbox" style={{ fontSize: '32px', display: 'block', marginBottom: '8px', opacity: 0.4 }}></i>
                    No hay PRE-ALTAS registradas
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Edit Modal */}
        {editando && (
          <div className="modal-overlay" onClick={() => setEditando(null)}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>
                  <i className="ti ti-edit"></i> Editar Candidato
                </h2>
                <button
                  className="modal-close"
                  onClick={() => setEditando(null)}
                >
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <div className="form-grid">
                  <Input
                    label="Nombre"
                    name="nombre"
                    value={editando.nombre}
                    onChange={(e) => setEditando({ ...editando, nombre: e.target.value })}
                    disabled
                  />
                  <Input
                    label="Email"
                    name="email"
                    value={editando.email}
                    onChange={(e) => setEditando({ ...editando, email: e.target.value })}
                    disabled
                  />
                  <Select
                    label="Puesto Previsto"
                    name="puesto_previsto"
                    value={editando.puesto_previsto || ''}
                    onChange={(e) => setEditando({ ...editando, puesto_previsto: e.target.value })}
                    opciones={['', ...getPuestosUnicos().filter(p => p)]}
                  />
                  <Input
                    label="Área Prevista"
                    name="area_prevista"
                    value={editando.area_prevista || ''}
                    onChange={(e) => setEditando({ ...editando, area_prevista: e.target.value })}
                  />
                  <Select
                    label="Fuente de Reclutamiento"
                    name="fuente_reclutamiento"
                    value={editando.fuente_reclutamiento || ''}
                    onChange={(e) => setEditando({ ...editando, fuente_reclutamiento: e.target.value })}
                    opciones={['', ...FUENTES_RECLUTAMIENTO]}
                  />
                  <Select
                    label="Estado"
                    name="estado_prealta"
                    value={editando.estado_prealta}
                    onChange={(e) => setEditando({ ...editando, estado_prealta: e.target.value })}
                    opciones={ESTADOS_PREALTA}
                  />
                  <Input
                    label="Puntuación"
                    name="puntuacion"
                    type="number"
                    step="0.1"
                    value={editando.puntuacion}
                    onChange={(e) => setEditando({ ...editando, puntuacion: e.target.value })}
                  />
                  <div style={{ gridColumn: '1 / -1' }}>
                    <Input
                      label="Comentarios"
                      name="comentarios"
                      value={editando.comentarios || ''}
                      onChange={(e) => setEditando({ ...editando, comentarios: e.target.value })}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn-secondary"
                  onClick={() => setEditando(null)}
                >
                  Cancelar
                </button>
                <button
                  className="btn-primary"
                  onClick={() => actualizarPrealta(editando.id_prealta, editando)}
                  disabled={loading}
                >
                  <i className="ti ti-device-floppy"></i>
                  Guardar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* History Modal */}
        {showHistorial && (
          <div className="modal-overlay" onClick={() => setShowHistorial(null)}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>
                  <i className="ti ti-history"></i> Historial de {showHistorial.nombre}
                </h2>
                <button
                  className="modal-close"
                  onClick={() => setShowHistorial(null)}
                >
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <div style={{
                    padding: '12px',
                    background: '#f3f4f6',
                    borderRadius: '8px',
                    borderLeft: '3px solid #0086ab'
                  }}>
                    <p style={{ margin: '0 0 4px 0', fontSize: '12px', fontWeight: 600, color: '#1d3d6b' }}>
                      {fmtFecha(showHistorial.fecha_creacion)}
                    </p>
                    <p style={{ margin: '0', fontSize: '12px', color: '#6b7280' }}>
                      Registro creado - Estado inicial: <strong>Nuevo</strong>
                    </p>
                  </div>
                  {showHistorial.estado_prealta !== 'Nuevo' && (
                    <div style={{
                      padding: '12px',
                      background: '#f3f4f6',
                      borderRadius: '8px',
                      borderLeft: '3px solid #3b82f6'
                    }}>
                      <p style={{ margin: '0 0 4px 0', fontSize: '12px', fontWeight: 600, color: '#1d3d6b' }}>
                        Estado Actual
                      </p>
                      <p style={{ margin: '0', fontSize: '12px', color: '#6b7280' }}>
                        Estado: <strong>{showHistorial.estado_prealta}</strong>
                      </p>
                    </div>
                  )}
                  {showHistorial.comentarios && (
                    <div style={{
                      padding: '12px',
                      background: '#f3f4f6',
                      borderRadius: '8px',
                      borderLeft: '3px solid #8b5cf6'
                    }}>
                      <p style={{ margin: '0 0 4px 0', fontSize: '12px', fontWeight: 600, color: '#1d3d6b' }}>
                        Comentarios
                      </p>
                      <p style={{ margin: '0', fontSize: '12px', color: '#6b7280' }}>
                        {showHistorial.comentarios}
                      </p>
                    </div>
                  )}
                  {showHistorial.puntuacion && (
                    <div style={{
                      padding: '12px',
                      background: '#f3f4f6',
                      borderRadius: '8px',
                      borderLeft: '3px solid #f59e0b'
                    }}>
                      <p style={{ margin: '0 0 4px 0', fontSize: '12px', fontWeight: 600, color: '#1d3d6b' }}>
                        Puntuación
                      </p>
                      <p style={{ margin: '0', fontSize: '12px', color: '#6b7280' }}>
                        {showHistorial.puntuacion} / 10
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn-secondary"
                  onClick={() => setShowHistorial(null)}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Procesar ALTA Tab */}
        {activeTab === 'procesar-alta' && (
          <div>
            {/* Success Modal */}
            {altaSuccessData && (
              <div className="modal-overlay" onClick={() => resetAltaForm()}>
                <div className="modal" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-header">
                    <h2>
                      <i className="ti ti-circle-check"></i> ¡Empleado Creado Exitosamente!
                    </h2>
                    <button className="modal-close" onClick={() => resetAltaForm()}>✕</button>
                  </div>
                  <div className="modal-body">
                    <div style={{
                      background: '#d1fae5',
                      border: '1px solid #6ee7b7',
                      borderRadius: '8px',
                      padding: '16px',
                      marginBottom: '16px',
                      color: '#065f46'
                    }}>
                      <p style={{ margin: '0 0 8px 0', fontWeight: 600, fontSize: '12px', color: '#047857' }}>
                        ID GENERADO
                      </p>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px' }}>
                        <input
                          type="text"
                          value={altaSuccessData.empleado_id}
                          onChange={(e) => setAltaSuccessData({ ...altaSuccessData, empleado_id: e.target.value })}
                          style={{
                            padding: '8px 12px',
                            border: '1px solid #6ee7b7',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontWeight: 600,
                            flex: 1,
                            fontFamily: 'monospace'
                          }}
                        />
                        <button
                          onClick={() => {
                            navigator.clipboard.writeText(altaSuccessData.empleado_id);
                            alert('ID copiado al portapapeles');
                          }}
                          style={{
                            padding: '8px 12px',
                            background: '#10b981',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: 600,
                            whiteSpace: 'nowrap'
                          }}
                        >
                          <i className="ti ti-copy"></i> Copiar
                        </button>
                      </div>
                      <p style={{ margin: '0', fontSize: '13px' }}>{altaSuccessData.nombre}</p>
                    </div>
                    <div className="info-grid">
                      <InfoCampo label="Puesto" valor={altaSuccessData.puesto_final} />
                      <InfoCampo label="Salario Base" valor={formatCurrencyMX(altaSuccessData.salario_base)} />
                      <InfoCampo label="Fecha Ingreso" valor={fmtFecha(altaSuccessData.fecha_ingreso)} />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button className="btn-secondary" onClick={() => resetAltaForm()}>
                      <i className="ti ti-plus"></i> Nuevo Ingreso
                    </button>
                    <button
                      className="btn-secondary"
                      onClick={() => alert('PDF será generado en próxima versión')}
                      style={{ opacity: 0.6, cursor: 'not-allowed' }}
                    >
                      <i className="ti ti-file-pdf"></i> Ver PDF
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Selector de Candidatos Modal */}
            {mostrarSelectorModal && (
              <div className="modal-overlay" onClick={() => setMostrarSelectorModal(false)}>
                <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
                  <div className="modal-header">
                    <h2>
                      <i className="ti ti-users"></i> Seleccionar Candidato
                    </h2>
                    <button className="modal-close" onClick={() => setMostrarSelectorModal(false)}>✕</button>
                  </div>
                  <div className="modal-body">
                    <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '16px' }}>
                      Selecciona un candidato PRE-ALTA para procesar su ingreso
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '400px', overflowY: 'auto' }}>
                      {prealtasDisponibles.map(prealta => (
                        <button
                          key={prealta.id_prealta}
                          onClick={() => {
                            seleccionarPrealta(prealta.id_prealta);
                            setMostrarSelectorModal(false);
                          }}
                          style={{
                            padding: '12px',
                            background: '#f3f4f6',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            textAlign: 'left',
                            cursor: 'pointer',
                            transition: 'all 0.2s',
                            fontSize: '14px'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background = '#0086ab';
                            e.target.style.color = 'white';
                            e.target.style.borderColor = '#0086ab';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = '#f3f4f6';
                            e.target.style.color = 'black';
                            e.target.style.borderColor = '#d1d5db';
                          }}
                        >
                          <div style={{ fontWeight: 600 }}>{prealta.nombre}</div>
                          <div style={{ fontSize: '12px', opacity: 0.7, marginTop: '4px' }}>
                            {prealta.puesto_previsto} • {prealta.sucursal}
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}


            {/* Wizard Form */}
            <div className="card">
              <div className="card-title">
                <i className="ti ti-briefcase"></i>
                Procesar ALTA (Paso {pasoAlta} de 7)
              </div>
              <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '16px' }}>
                Convertir candidato PRE-ALTA en empleado contratado
              </div>

              {/* Progress Bar */}
              <div style={{ marginBottom: '20px' }}>
                <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
                  {[1, 2, 3, 4, 5, 6, 7].map(p => (
                    <div
                      key={p}
                      style={{
                        flex: 1,
                        height: '4px',
                        background: p <= pasoAlta ? '#0086ab' : '#e5e7eb',
                        borderRadius: '2px',
                        transition: 'all 0.3s'
                      }}
                    />
                  ))}
                </div>
              </div>

              {/* Step 1: Select PRE-ALTA Candidate */}
              {pasoAlta === 1 && (
                <div>
                  <SeccionLabel icon="ti-search">Seleccionar Candidato</SeccionLabel>
                  <div className="form-grid">
                    <div>
                      <Select
                        label="Candidato (PRE-ALTA) *"
                        name="prealta_id"
                        value={altaData.prealta_id}
                        onChange={(e) => seleccionarPrealta(e.target.value)}
                        opciones={prealtasDisponibles.map(p => ({
                          value: p.id_prealta,
                          label: `${p.nombre} - ${p.puesto_previsto}`
                        }))}
                      />
                      {altaFormErrors.prealta_id && <span style={{ color: '#dc2626', fontSize: '12px' }}>{altaFormErrors.prealta_id}</span>}
                    </div>
                  </div>

                  {altaData.prealtaDetails && (
                    <div style={{ marginTop: '16px' }}>
                      <SeccionLabel icon="ti-user">Información del Candidato</SeccionLabel>
                      <div className="info-grid">
                        <InfoCampo label="Nombre" valor={altaData.prealtaDetails.nombre} />
                        <InfoCampo label="Email" valor={altaData.prealtaDetails.email} />
                        <InfoCampo label="Teléfono" valor={altaData.prealtaDetails.telefono} />
                        <InfoCampo label="Puesto" valor={altaData.prealtaDetails.puesto_previsto} />
                        <InfoCampo label="Área" valor={altaData.prealtaDetails.area_prevista} />
                        <InfoCampo label="Fuente" valor={altaData.prealtaDetails.fuente_reclutamiento} />
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Step 2: Create Nuevo Empleado */}
              {pasoAlta === 2 && (
                <div>
                  {console.log('🔍 Paso 2 - sucursalesList:', sucursalesList)}
                  {sucursalesList.length > 0 && console.log('📋 Primera sucursal:', sucursalesList[0])}
                  {ubicacionesList.length > 0 && console.log('📋 Primera ubicación:', ubicacionesList[0])}
                  {centrosList.length > 0 && console.log('📋 Primer centro:', centrosList[0])}
                  {nodosList.length > 0 && console.log('📋 Primer nodo:', nodosList[0])}
                  <SeccionLabel icon="ti-user-plus">Crear Nuevo Empleado</SeccionLabel>

                  <div className="modal-tabs" style={{ marginBottom: '20px', borderBottom: '1px solid #e5e7eb' }}>
                    {[1, 2, 3].map(t => (
                      <button
                        key={t}
                        className={`modal-tab ${tabNuevoIngreso === t ? 'active' : ''}`}
                        onClick={() => setTabNuevoIngreso(t)}
                        style={{
                          padding: '8px 16px',
                          background: tabNuevoIngreso === t ? '#0086ab' : 'transparent',
                          color: tabNuevoIngreso === t ? 'white' : '#6b7280',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '13px',
                          fontWeight: 500
                        }}
                      >
                        {t === 1 ? '1. Identificación' : t === 2 ? '2. Documentos' : '3. Domicilio'}
                      </button>
                    ))}
                  </div>

                  {/* Tab 1: Identificación */}
                  {tabNuevoIngreso === 1 && (
                    <div>
                      <div className="form-grid">
                        <Input
                          label="ID Empleado *"
                          name="id_empleado"
                          value={altaData.id_empleado}
                          onChange={(e) => setAltaData({ ...altaData, id_empleado: e.target.value })}
                          placeholder="Ej: EMP001"
                        />
                        <Input
                          label="Nombres *"
                          name="nombres"
                          value={altaData.nombres || ''}
                          onChange={(e) => setAltaData({ ...altaData, nombres: e.target.value })}
                        />
                        <Input
                          label="Apellido Paterno *"
                          name="apellido_paterno"
                          value={altaData.apellido_paterno || ''}
                          onChange={(e) => setAltaData({ ...altaData, apellido_paterno: e.target.value })}
                        />
                        <Input
                          label="Apellido Materno *"
                          name="apellido_materno"
                          value={altaData.apellido_materno || ''}
                          onChange={(e) => setAltaData({ ...altaData, apellido_materno: e.target.value })}
                        />
                        <Input
                          label="CURP *"
                          name="curp"
                          value={altaData.curp || ''}
                          onChange={(e) => setAltaData({ ...altaData, curp: e.target.value.toUpperCase() })}
                          maxLength="18"
                        />
                        <Input
                          label="RFC *"
                          name="rfc"
                          value={altaData.rfc || ''}
                          onChange={(e) => setAltaData({ ...altaData, rfc: e.target.value.toUpperCase() })}
                          maxLength="13"
                        />
                        <Input
                          label="Email"
                          name="email"
                          type="email"
                          value={altaData.email || ''}
                          onChange={(e) => setAltaData({ ...altaData, email: e.target.value })}
                        />
                        <Input
                          label="Teléfono *"
                          name="telefono"
                          value={altaData.telefono || ''}
                          onChange={(e) => setAltaData({ ...altaData, telefono: e.target.value })}
                        />
                      </div>

                      <SeccionLabel icon="ti-briefcase" style={{ marginTop: '20px' }}>Datos de Ingreso</SeccionLabel>
                      <div className="form-grid">
                        <Select
                          label="Sucursal *"
                          name="sucursal_final"
                          value={altaData.sucursal_final || ''}
                          onChange={(e) => {
                            const sucSelected = sucursalesList.find(s => s.Nombre === e.target.value);
                            setAltaData({ ...altaData, sucursal_final: sucSelected?.Nombre || '', ubicacion_final: '', centro_final: '', nodo_final: '', nodo_id: '', puesto_final: '', area_final: '' });
                          }}
                          opciones={sucursalesList.map(s => ({ value: s.Nombre, label: s.Nombre }))}
                        />
                        <Select
                          label="Ubicación Física *"
                          name="ubicacion_final"
                          value={altaData.ubicacion_final || ''}
                          onChange={(e) => setAltaData({ ...altaData, ubicacion_final: e.target.value, centro_final: '', nodo_final: '', nodo_id: '', puesto_final: '', area_final: '' })}
                          opciones={obtenerUbicacionesPorSucursal(altaData.sucursal_final).map(u => ({ value: u.ID_Ubicacion, label: u.Nombre_Ubicacion }))}
                          disabled={!altaData.sucursal_final}
                        />
                        <Select
                          label="Centro de Costos *"
                          name="centro_final"
                          value={altaData.centro_final || ''}
                          onChange={(e) => {
                            const centroSelected = obtenerCentrosPorUbicacion(altaData.ubicacion_final).find(c => c.ID_Centro === e.target.value);
                            const areaCentro = centroSelected?.AREA || centroSelected?.Área || centroSelected?.Area || '';
                            setAltaData({ ...altaData, centro_final: e.target.value, nodo_final: '', nodo_id: '', puesto_final: '', area_final: areaCentro });
                          }}
                          opciones={obtenerCentrosPorUbicacion(altaData.ubicacion_final).map(c => ({ value: c.ID_Centro, label: c.Centro_Costos }))}
                          disabled={!altaData.ubicacion_final}
                        />
                        <Select
                          label="Nodo *"
                          name="nodo_final"
                          value={altaData.nodo_final || ''}
                          onChange={(e) => {
                            const nodoSelected = obtenerNodosPorCentro(altaData.centro_final).find(n => n.Nodo_ID === e.target.value);
                            setAltaData({ ...altaData, nodo_final: e.target.value, nodo_id: e.target.value, puesto_final: nodoSelected?.Puesto || '' });
                          }}
                          opciones={obtenerNodosPorCentro(altaData.centro_final).map(n => ({ value: n.Nodo_ID, label: n.Nombre_Nodo }))}
                          disabled={!altaData.centro_final}
                        />
                        <Select
                          label="Puesto *"
                          name="puesto_final"
                          value={altaData.puesto_final || ''}
                          onChange={(e) => setAltaData({ ...altaData, puesto_final: e.target.value })}
                          opciones={altaData.puesto_final ? [{ value: altaData.puesto_final, label: altaData.puesto_final }] : []}
                          disabled={true}
                        />
                        <Input
                          label="Fecha de Ingreso *"
                          name="fecha_ingreso"
                          type="date"
                          value={altaData.fecha_ingreso}
                          onChange={(e) => setAltaData({ ...altaData, fecha_ingreso: e.target.value })}
                        />
                        <Input
                          label="Salario Base *"
                          name="salario_base"
                          type="number"
                          value={altaData.salario_base}
                          onChange={(e) => setAltaData({ ...altaData, salario_base: e.target.value })}
                        />
                      </div>
                    </div>
                  )}

                  {/* Tab 2: Documentos */}
                  {tabNuevoIngreso === 2 && (
                    <div>
                      <SeccionLabel icon="ti-file">Documentos Requeridos</SeccionLabel>
                      <div style={{ color: '#6b7280', fontSize: '13px', marginBottom: '16px' }}>
                        Estos campos serán habilitados después de crear el empleado
                      </div>
                    </div>
                  )}

                  {/* Tab 3: Domicilio */}
                  {tabNuevoIngreso === 3 && (
                    <div>
                      <SeccionLabel icon="ti-map">Información de Domicilio</SeccionLabel>
                      <div className="form-grid">
                        <Input
                          label="Calle *"
                          name="calle"
                          value={altaData.domicilio?.calle || ''}
                          onChange={(e) => setAltaData({ ...altaData, domicilio: { ...altaData.domicilio, calle: e.target.value } })}
                        />
                        <Input
                          label="Número *"
                          name="numero"
                          value={altaData.domicilio?.numero || ''}
                          onChange={(e) => setAltaData({ ...altaData, domicilio: { ...altaData.domicilio, numero: e.target.value } })}
                        />
                        <Input
                          label="Apartamento"
                          name="apartamento"
                          value={altaData.domicilio?.apartamento || ''}
                          onChange={(e) => setAltaData({ ...altaData, domicilio: { ...altaData.domicilio, apartamento: e.target.value } })}
                        />
                        <Input
                          label="Colonia *"
                          name="colonia"
                          value={altaData.domicilio?.colonia || ''}
                          onChange={(e) => setAltaData({ ...altaData, domicilio: { ...altaData.domicilio, colonia: e.target.value } })}
                        />
                        <Input
                          label="Ciudad *"
                          name="ciudad"
                          value={altaData.domicilio?.ciudad || ''}
                          onChange={(e) => setAltaData({ ...altaData, domicilio: { ...altaData.domicilio, ciudad: e.target.value } })}
                        />
                        <Input
                          label="Estado/Provincia *"
                          name="estado"
                          value={altaData.domicilio?.estado || ''}
                          onChange={(e) => setAltaData({ ...altaData, domicilio: { ...altaData.domicilio, estado: e.target.value } })}
                        />
                        <Input
                          label="Código Postal *"
                          name="codigo_postal"
                          value={altaData.domicilio?.codigo_postal || ''}
                          onChange={(e) => setAltaData({ ...altaData, domicilio: { ...altaData.domicilio, codigo_postal: e.target.value } })}
                        />
                      </div>
                    </div>
                  )}
                  {Object.keys(altaFormErrors).length > 0 && (
                    <div style={{
                      background: '#fef2f2',
                      border: '1px solid #fecaca',
                      borderRadius: '8px',
                      padding: '12px 14px',
                      marginTop: '16px',
                      fontSize: '13px',
                      color: '#dc2626'
                    }}>
                      <i className="ti ti-alert-circle" style={{ marginRight: '6px' }}></i>
                      <strong>Faltan campos en la pestaña "1. Identificación":</strong>
                      <ul style={{ margin: '6px 0 0 0', paddingLeft: '20px' }}>
                        {Object.values(altaFormErrors).map((msg, i) => (
                          <li key={i}>{msg}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}

              {/* Step 3: Confirm Node & Position (data already set in Step 2 - Identificación) */}
              {pasoAlta === 3 && (
                <div>
                  <SeccionLabel icon="ti-map-2">Confirmar Nodo, Puesto y Área</SeccionLabel>
                  <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '12px' }}>
                    Nodo y Puesto se definieron en el paso anterior (pestaña "1. Identificación"). El Área se autocompleta según el Centro de Costos seleccionado.
                  </div>
                  <div className="info-grid">
                    <InfoCampo label="Nodo_ID" valor={altaData.nodo_id || '—'} />
                    <InfoCampo label="Puesto Final" valor={altaData.puesto_final || '—'} />
                  </div>
                  {(altaFormErrors.nodo_id || altaFormErrors.puesto_final) && (
                    <div style={{ color: '#dc2626', fontSize: '12px', marginTop: '6px' }}>
                      Vuelve al paso anterior y completa Centro de Costos / Nodo en "1. Identificación".
                    </div>
                  )}
                  <div className="form-grid" style={{ marginTop: '16px' }}>
                    <div>
                      <Input
                        label="Área Final *"
                        name="area_final"
                        value={altaData.area_final}
                        onChange={(e) => setAltaData({ ...altaData, area_final: e.target.value })}
                      />
                      {altaFormErrors.area_final && <span style={{ color: '#dc2626', fontSize: '12px' }}>{altaFormErrors.area_final}</span>}
                    </div>
                  </div>
                  <div style={{
                    background: '#f3f4f6',
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '12px 14px',
                    marginTop: '16px',
                    fontSize: '12px',
                    color: '#6b7280'
                  }}>
                    <i className="ti ti-info-circle" style={{ marginRight: '6px' }}></i>
                    Estos datos determinarán la ubicación del empleado en la estructura organizacional
                  </div>
                </div>
              )}

              {/* Step 3: Set Salary and Start Date */}
              {pasoAlta === 4 && (
                <div>
                  <SeccionLabel icon="ti-currency-peso">Establecer Salario y Fecha de Inicio</SeccionLabel>

                  {/* Salary Mode Toggle */}
                  <div style={{ marginBottom: '20px' }}>
                    <div style={{ fontSize: '12px', fontWeight: 600, color: '#1f2937', marginBottom: '8px' }}>
                      Tipo de Salario
                    </div>
                    <div style={{ display: 'flex', gap: '16px' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                        <input
                          type="radio"
                          name="salario_mode"
                          checked={salarioMode === 'mensual'}
                          onChange={() => setSalarioMode('mensual')}
                          style={{ cursor: 'pointer' }}
                        />
                        <span style={{ fontSize: '13px' }}>Salario Mensual</span>
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                        <input
                          type="radio"
                          name="salario_mode"
                          checked={salarioMode === 'diario'}
                          onChange={() => setSalarioMode('diario')}
                          style={{ cursor: 'pointer' }}
                        />
                        <span style={{ fontSize: '13px' }}>Salario Diario</span>
                      </label>
                    </div>
                  </div>

                  <div className="form-grid">
                    {salarioMode === 'mensual' ? (
                      <div>
                        <Input
                          label="Salario Mensual (MXN) *"
                          name="salario_base"
                          type="number"
                          value={altaData.salario_base}
                          onChange={(e) => setAltaData({ ...altaData, salario_base: e.target.value })}
                        />
                        {altaFormErrors.salario_base && <span style={{ color: '#dc2626', fontSize: '12px' }}>{altaFormErrors.salario_base}</span>}
                      </div>
                    ) : (
                      <div>
                        <Input
                          label="Salario Diario (MXN) *"
                          name="salario_diario"
                          type="number"
                          value={altaData.salario_diario}
                          onChange={(e) => setAltaData({ ...altaData, salario_diario: e.target.value })}
                        />
                        {altaFormErrors.salario_base && <span style={{ color: '#dc2626', fontSize: '12px' }}>{altaFormErrors.salario_base}</span>}
                      </div>
                    )}
                    <Input
                      label="Fecha de Inicio de Labores *"
                      name="fecha_ingreso"
                      type="date"
                      value={altaData.fecha_ingreso}
                      onChange={(e) => setAltaData({ ...altaData, fecha_ingreso: e.target.value })}
                    />
                  </div>

                  {((salarioMode === 'mensual' && altaData.salario_base && parseFloat(altaData.salario_base) > 0) ||
                    (salarioMode === 'diario' && altaData.salario_diario && parseFloat(altaData.salario_diario) > 0)) && (
                    <div style={{ marginTop: '16px' }}>
                      <SeccionLabel icon="ti-calculator">Desglose Salarial</SeccionLabel>
                      <div style={{
                        background: '#eff6ff',
                        border: '1px solid #bfdbfe',
                        borderRadius: '8px',
                        padding: '16px',
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: '16px'
                      }}>
                        {(() => {
                          let desglose;
                          if (salarioMode === 'mensual') {
                            desglose = calcularSalarioDesglose(altaData.salario_base);
                          } else {
                            // Calculate from daily salary
                            const diario = parseFloat(altaData.salario_diario) || 0;
                            const bonoRecomendacion = 200;
                            const fondoAhorro = (diario * 30.4 * 0.04).toFixed(2);
                            desglose = {
                              diario: diario.toFixed(2),
                              semanal: (diario * 7).toFixed(2),
                              mensual: (diario * 30.4).toFixed(2),
                              bonoRecomendacion: bonoRecomendacion.toFixed(2),
                              fondoAhorro: parseFloat(fondoAhorro).toFixed(2),
                              totalConBonos: ((diario * 30.4) + bonoRecomendacion).toFixed(2)
                            };
                          }
                          return (
                            <>
                              <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>Salario Diario</div>
                                <div style={{ fontSize: '14px', fontWeight: 600, color: '#0086ab' }}>
                                  {formatCurrencyMX(desglose.diario)}
                                </div>
                              </div>
                              <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>Salario Semanal</div>
                                <div style={{ fontSize: '14px', fontWeight: 600, color: '#0086ab' }}>
                                  {formatCurrencyMX(desglose.semanal)}
                                </div>
                              </div>
                              <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>Salario Mensual (30.4 días)</div>
                                <div style={{ fontSize: '14px', fontWeight: 600, color: '#0086ab' }}>
                                  {formatCurrencyMX(desglose.mensual)}
                                </div>
                              </div>
                              <div style={{ textAlign: 'center', borderTop: '1px solid #93c5fd', paddingTop: '12px' }}>
                                <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>Bono Recomendación</div>
                                <div style={{ fontSize: '14px', fontWeight: 600, color: '#059669' }}>
                                  {formatCurrencyMX(desglose.bonoRecomendacion || 200)}
                                </div>
                              </div>
                              <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>Fondo Ahorro (4%)</div>
                                <div style={{ fontSize: '14px', fontWeight: 600, color: '#dc2626' }}>
                                  -{formatCurrencyMX(desglose.fondoAhorro || 0)}
                                </div>
                              </div>
                              <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>Total Mensual c/ Bonos</div>
                                <div style={{ fontSize: '14px', fontWeight: 700, color: '#0086ab', background: '#ecfdf5', padding: '6px', borderRadius: '6px' }}>
                                  {formatCurrencyMX(desglose.totalConBonos || desglose.mensual)}
                                </div>
                              </div>
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  )}

                  {/* Vales de Despensa */}
                  <div style={{ marginTop: '20px', marginBottom: '16px' }}>
                    <div style={{ fontSize: '12px', fontWeight: 600, color: '#1f2937', marginBottom: '8px' }}>
                      Vales de Despensa (Extra)
                    </div>
                    <div style={{ display: 'flex', gap: '16px' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                        <input
                          type="radio"
                          name="vales_despensa"
                          value="600"
                          checked={altaData.valesDespensa === '600'}
                          onChange={() => setAltaData({ ...altaData, valesDespensa: '600' })}
                          style={{ cursor: 'pointer' }}
                        />
                        <span style={{ fontSize: '13px' }}>$600</span>
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                        <input
                          type="radio"
                          name="vales_despensa"
                          value="750"
                          checked={altaData.valesDespensa === '750'}
                          onChange={() => setAltaData({ ...altaData, valesDespensa: '750' })}
                          style={{ cursor: 'pointer' }}
                        />
                        <span style={{ fontSize: '13px' }}>$750</span>
                      </label>
                    </div>
                    <div style={{
                      fontSize: '11px',
                      color: '#6b7280',
                      marginTop: '6px',
                      fontStyle: 'italic'
                    }}>
                      Los vales de despensa son un agregado extra y no afectan el cálculo del salario base.
                    </div>
                  </div>

                  <div style={{
                    background: '#f3f4f6',
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '12px 14px',
                    marginTop: '16px',
                    fontSize: '12px',
                    color: '#6b7280'
                  }}>
                    <i className="ti ti-info-circle" style={{ marginRight: '6px' }}></i>
                    El salario se registrará en la Propuesta Salarial. La fecha de inicio será la fecha de ingreso en el sistema. Vales de despensa: {formatCurrencyMX(altaData.valesDespensa)}/mes
                  </div>
                </div>
              )}

              {/* Step 4: Review Guarantee */}
              {pasoAlta === 5 && (
                <div>
                  <SeccionLabel icon="ti-shield">Revisar Garantía de Agencia</SeccionLabel>

                  {altaData.agencia_id ? (
                    <div style={{
                      background: '#ecfdf5',
                      border: '1px solid #a7f3d0',
                      borderRadius: '8px',
                      padding: '16px',
                      marginBottom: '16px'
                    }}>
                      <div style={{ fontWeight: 600, color: '#065f46', marginBottom: '8px' }}>
                        <i className="ti ti-check" style={{ marginRight: '6px' }}></i>
                        Garantía de Agencia
                      </div>
                      <div style={{ fontSize: '13px', color: '#047857', lineHeight: '1.6' }}>
                        <p style={{ margin: '0 0 8px 0' }}>
                          <strong>Agencia:</strong> {altaData.agencia_id}
                        </p>
                        <p style={{ margin: '0 0 8px 0' }}>
                          <strong>Días Garantía:</strong> 30 días
                        </p>
                        <p style={{ margin: '0' }}>
                          <strong>Costo:</strong> $500
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div style={{
                      background: '#fef3c7',
                      border: '1px solid #fcd34d',
                      borderRadius: '8px',
                      padding: '16px',
                      marginBottom: '16px',
                      color: '#92400e',
                      fontSize: '13px'
                    }}>
                      <i className="ti ti-info-circle" style={{ marginRight: '6px' }}></i>
                      No hay garantía de agencia para este ingreso
                    </div>
                  )}

                  <div style={{ marginTop: '16px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px' }}>
                      <input
                        type="checkbox"
                        checked={altaConfirmGarantia}
                        onChange={(e) => setAltaConfirmGarantia(e.target.checked)}
                        style={{ cursor: 'pointer' }}
                      />
                      Confirmo los términos de garantía
                    </label>
                    {altaFormErrors.garantia && <div style={{ color: '#dc2626', fontSize: '12px', marginTop: '6px' }}>{altaFormErrors.garantia}</div>}
                  </div>
                </div>
              )}

              {/* Step 5: Review Bonus */}
              {pasoAlta === 6 && (
                <div>
                  <SeccionLabel icon="ti-gift">Revisar Bono de Referencia</SeccionLabel>

                  {altaData.recomendador_id ? (
                    <div>
                      <div style={{
                        background: '#fef3c7',
                        border: '1px solid #fcd34d',
                        borderRadius: '8px',
                        padding: '16px',
                        marginBottom: '16px'
                      }}>
                        <div style={{ fontWeight: 600, color: '#92400e', marginBottom: '8px', fontSize: '13px' }}>
                          <i className="ti ti-gift" style={{ marginRight: '6px' }}></i>
                          Bono de Referencia Aplica
                        </div>
                        <div style={{ fontSize: '13px', color: '#92400e', lineHeight: '1.6' }}>
                          <p style={{ margin: '0 0 8px 0' }}>
                            <strong>Referido por Empleado ID:</strong> {altaData.recomendador_id}
                          </p>
                          <p style={{ margin: '0 0 8px 0' }}>
                            <strong>Primer Pago:</strong> $1,000 en fecha de ingreso
                          </p>
                          <p style={{ margin: '0 0 8px 0' }}>
                            <strong>Segundo Pago:</strong> $1,000 en +90 días
                          </p>
                          <p style={{ margin: '0', fontSize: '14px', fontWeight: 600, color: '#b45309' }}>
                            <strong>Total:</strong> $2,000
                          </p>
                        </div>
                      </div>

                      <div style={{ marginTop: '16px' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px' }}>
                          <input
                            type="checkbox"
                            checked={altaConfirmBonus}
                            onChange={(e) => setAltaConfirmBonus(e.target.checked)}
                            style={{ cursor: 'pointer' }}
                          />
                          Confirmo los términos de bono de referencia
                        </label>
                        {altaFormErrors.bonus && <div style={{ color: '#dc2626', fontSize: '12px', marginTop: '6px' }}>{altaFormErrors.bonus}</div>}
                      </div>
                    </div>
                  ) : (
                    <div style={{
                      background: '#f3f4f6',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      padding: '16px',
                      color: '#6b7280',
                      fontSize: '13px',
                      textAlign: 'center'
                    }}>
                      <i className="ti ti-circle-x" style={{ fontSize: '24px', display: 'block', marginBottom: '8px', opacity: 0.5 }}></i>
                      Este candidato no tiene bono de referencia
                    </div>
                  )}
                </div>
              )}

              {/* Step 6: Confirmation */}
              {pasoAlta === 7 && (
                <div>
                  <SeccionLabel icon="ti-circle-check">Confirmar Conversión</SeccionLabel>

                  {/* Summary Cards */}
                  <div style={{ display: 'grid', gap: '16px', marginBottom: '16px' }}>
                    {/* EMPLEADO Card */}
                    <div style={{
                      background: '#eff6ff',
                      border: '1px solid #bfdbfe',
                      borderRadius: '8px',
                      padding: '16px'
                    }}>
                      <div style={{ fontWeight: 600, color: '#1e40af', marginBottom: '12px', fontSize: '13px' }}>
                        <i className="ti ti-briefcase" style={{ marginRight: '6px' }}></i>
                        EMPLEADO
                      </div>
                      <div className="info-grid">
                        <InfoCampo label="Nombre" valor={altaData.prealtaDetails?.nombre} />
                        <InfoCampo label="Puesto" valor={altaData.puesto_final} />
                        <InfoCampo label="Área" valor={altaData.area_final} />
                        <InfoCampo label="Salario Base" valor={`$${parseFloat(altaData.salario_base).toLocaleString('es-MX')}`} />
                      </div>
                    </div>

                    {/* GARANTIA Card */}
                    {altaData.agencia_id && (
                      <div style={{
                        background: '#ecfdf5',
                        border: '1px solid #a7f3d0',
                        borderRadius: '8px',
                        padding: '16px'
                      }}>
                        <div style={{ fontWeight: 600, color: '#065f46', marginBottom: '12px', fontSize: '13px' }}>
                          <i className="ti ti-shield" style={{ marginRight: '6px' }}></i>
                          GARANTIA
                        </div>
                        <div className="info-grid">
                          <InfoCampo label="Agencia" valor={altaData.agencia_id} />
                          <InfoCampo label="Días Garantía" valor="30" />
                          <InfoCampo label="Costo" valor="$500" />
                        </div>
                      </div>
                    )}

                    {/* BONO Card */}
                    {altaData.recomendador_id && (
                      <div style={{
                        background: '#fffbeb',
                        border: '1px solid #fde68a',
                        borderRadius: '8px',
                        padding: '16px'
                      }}>
                        <div style={{ fontWeight: 600, color: '#92400e', marginBottom: '12px', fontSize: '13px' }}>
                          <i className="ti ti-gift" style={{ marginRight: '6px' }}></i>
                          BONO
                        </div>
                        <div className="info-grid">
                          <InfoCampo label="Referidor ID" valor={altaData.recomendador_id} />
                          <InfoCampo label="Primer Pago" valor="$1,000" />
                          <InfoCampo label="Segundo Pago" valor="$1,000" />
                          <InfoCampo label="Total" valor="$2,000" highlight={true} />
                        </div>
                      </div>
                    )}
                  </div>

                  {/* PDF Section */}
                  <div style={{
                    background: '#f3f4f6',
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '16px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontWeight: 600, marginBottom: '8px', fontSize: '13px' }}>
                      <i className="ti ti-file-pdf" style={{ marginRight: '6px' }}></i>
                      Propuesta Salarial
                    </div>
                    <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '12px' }}>
                      Se generará automáticamente al completar
                    </div>
                    <button
                      disabled={true}
                      style={{
                        padding: '8px 16px',
                        background: '#d1d5db',
                        color: '#6b7280',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '12px',
                        fontWeight: 600,
                        cursor: 'not-allowed'
                      }}
                    >
                      <i className="ti ti-download"></i> Ver PDF
                    </button>
                  </div>
                </div>
              )}

              {/* Navigation Buttons */}
              <div style={{
                display: 'flex',
                gap: '12px',
                marginTop: '24px',
                justifyContent: 'space-between'
              }}>
                <div>
                  {pasoAlta > 1 && (
                    <button
                      onClick={retrocederPasoAlta}
                      style={{
                        padding: '8px 16px',
                        background: '#e5e7eb',
                        color: '#1f2937',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '12px',
                        fontWeight: 600,
                        cursor: 'pointer'
                      }}
                    >
                      <i className="ti ti-arrow-left" style={{ marginRight: '6px' }}></i>
                      Anterior
                    </button>
                  )}
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button
                    onClick={resetAltaForm}
                    style={{
                      padding: '8px 16px',
                      background: '#f3f4f6',
                      color: '#6b7280',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '12px',
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}
                  >
                    Cancelar
                  </button>
                  {pasoAlta < 7 ? (
                    <button
                      onClick={avanzarPasoAlta}
                      style={{
                        padding: '8px 16px',
                        background: '#0086ab',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '12px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}
                    >
                      Siguiente
                      <i className="ti ti-arrow-right"></i>
                    </button>
                  ) : (
                    <button
                      onClick={crearAltaFromWizard}
                      disabled={loading}
                      style={{
                        padding: '8px 16px',
                        background: '#10b981',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '12px',
                        fontWeight: 600,
                        cursor: loading ? 'not-allowed' : 'pointer',
                        opacity: loading ? 0.6 : 1,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}
                    >
                      <i className="ti ti-device-floppy"></i>
                      {loading ? 'Procesando...' : 'Confirmar Conversión'}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Documentos Tab */}
        {activeTab === 'documentos' && (() => {
          const sucursalesUnicas = [...new Set(prealtasData.map(p => p.sucursal))].sort();

          let datos = prealtasData.map((p, idx) => {
            let docs = {};
            try {
              if (p.documento_completo && typeof p.documento_completo === 'string') {
                const parsed = JSON.parse(p.documento_completo);
                if (Array.isArray(parsed)) {
                  docs = parsed.reduce((acc, doc) => { acc[doc.toLowerCase()] = true; return acc; }, {});
                }
              }
            } catch (e) {}

            const estados = {
              domicilio: !!docs['comprobante domicilio'],
              fiscal: !!docs['constancia fiscal'],
              estudios: !!docs['comprobante de estudios'],
              imss: !!docs['número de seguro social'],
              acta: !!docs['acta de nacimiento'],
              ine: !!docs['identificación oficial (ine)'],
              curp: !!docs['curp'],
              reglamentos: false,
              actualizacion_datos: false,
              carta_adeudos: false,
              checklist: false,
              confidencialidad: false,
              contrato_laboral: false,
              equipo_seguridad: false,
              gafete: false,
              reglamento_interno: false
            };

            const faltantes = Object.entries(estados)
              .filter(([, tiene]) => !tiene)
              .map(([doc]) => doc.charAt(0).toUpperCase() + doc.slice(1));

            return { ...p, idx, estados, faltantes };
          });

          if (filtroSucursal) datos = datos.filter(d => d.sucursal === filtroSucursal);
          if (soloFaltantes) datos = datos.filter(d => d.faltantes.length > 0);

          datos.sort((a, b) => {
            const idA = parseInt(a.id_prealta) || 0;
            const idB = parseInt(b.id_prealta) || 0;
            return idB - idA;
          });

          return (
            <div className="card">
              <div className="card-title">
                <i className="ti ti-files"></i>
                Control de Documentos
              </div>
              <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '20px' }}>
                Gestiona los documentos verificados de candidatos y empleados
              </div>

              {/* Filtros */}
              <div style={{ display: 'flex', gap: '20px', marginBottom: '20px', flexWrap: 'wrap', alignItems: 'center' }}>
                <div style={{ flex: 1, minWidth: '200px' }}>
                  <label style={{ fontSize: '12px', fontWeight: 600, color: '#6b7280', marginBottom: '4px', display: 'block' }}>Filtrar por Sucursal</label>
                  <select
                    value={filtroSucursal}
                    onChange={(e) => setFiltroSucursal(e.target.value)}
                    style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '14px' }}
                  >
                    <option value="">Todas las sucursales</option>
                    {sucursalesUnicas.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginTop: '24px' }}>
                  <input
                    type="checkbox"
                    checked={soloFaltantes}
                    onChange={(e) => setSoloFaltantes(e.target.checked)}
                    style={{ cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '14px' }}>Solo mostrar con faltantes</span>
                </label>
              </div>

              {/* Tabla */}
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f3f4f6', borderBottom: '2px solid #e5e7eb' }}>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600 }}>Candidato</th>
                      <th style={{ padding: '12px', textAlign: 'center', fontWeight: 600, fontSize: '12px' }}>Domicilio</th>
                      <th style={{ padding: '12px', textAlign: 'center', fontWeight: 600, fontSize: '12px' }}>Fiscal</th>
                      <th style={{ padding: '12px', textAlign: 'center', fontWeight: 600, fontSize: '12px' }}>Estudios</th>
                      <th style={{ padding: '12px', textAlign: 'center', fontWeight: 600, fontSize: '12px' }}>IMSS</th>
                      <th style={{ padding: '12px', textAlign: 'center', fontWeight: 600, fontSize: '12px' }}>Acta</th>
                      <th style={{ padding: '12px', textAlign: 'center', fontWeight: 600, fontSize: '12px' }}>INE</th>
                      <th style={{ padding: '12px', textAlign: 'center', fontWeight: 600, fontSize: '12px' }}>CURP</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600 }}>Falta</th>
                    </tr>
                  </thead>
                  <tbody>
                    {datos.map((d) => (
                      <tr key={d.id_prealta} style={{ borderBottom: '1px solid #e5e7eb' }}>
                        <td style={{ padding: '12px', fontWeight: 500 }}>{d.nombre}</td>
                        {['domicilio', 'fiscal', 'estudios', 'imss', 'acta', 'ine', 'curp', 'reglamentos', 'actualizacion_datos', 'carta_adeudos', 'checklist', 'confidencialidad', 'contrato_laboral', 'equipo_seguridad', 'gafete', 'reglamento_interno'].map(doc => {
                          const key = `${d.id_prealta}-${doc}`;
                          const tiene = docsEditables[key] || false;
                          return (
                            <td
                              key={doc}
                              onClick={() => toggleDoc(d.id_prealta, doc)}
                              style={{
                                padding: '12px',
                                textAlign: 'center',
                                cursor: 'pointer',
                                backgroundColor: tiene ? '#d1fae5' : '#fee2e2',
                                borderRadius: '4px',
                                userSelect: 'none'
                              }}
                              title="Click para cambiar"
                            >
                              {tiene ? '✅' : '❌'}
                            </td>
                          );
                        })}
                        <td style={{ padding: '12px', fontSize: '12px', color: d.faltantes.length > 0 ? '#dc2626' : '#10b981', fontWeight: 600 }}>
                          {d.faltantes.length > 0 ? d.faltantes.join(', ') : 'Completo'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {datos.length === 0 && (
                <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
                  <i className="ti ti-inbox" style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.5 }}></i>
                  <p>No hay candidatos que coincidan con los filtros</p>
                </div>
              )}
            </div>
          );
        })()}

        {/* Garantías Tab */}
        {activeTab === 'garantias' && (
          <div>
            {successMessage && (
              <div style={{
                background: '#d1fae5',
                border: '1px solid #6ee7b7',
                borderRadius: '8px',
                padding: '12px 16px',
                marginBottom: '16px',
                color: '#065f46',
                fontSize: '13px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <i className="ti ti-check"></i>
                {successMessage}
              </div>
            )}

            {/* Main Card */}
            <div className="card">
              <div className="card-title">
                <i className="ti ti-shield"></i>
                Garantías, Bonos y Reportes
              </div>
              <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '16px' }}>
                Gestión de garantías de agencias, bonos de referencia y reportes financieros
              </div>

              {/* Sub-Tabs Navigation */}
              <div style={{ marginBottom: '20px', borderBottom: '1px solid #e5e7eb' }}>
                <div style={{ display: 'flex', gap: '4px' }}>
                  <button
                    onClick={() => setTabGarantias('garantias')}
                    style={{
                      padding: '12px 16px',
                      background: tabGarantias === 'garantias' ? '#0086ab' : 'transparent',
                      color: tabGarantias === 'garantias' ? 'white' : '#6b7280',
                      border: 'none',
                      borderBottom: tabGarantias === 'garantias' ? '2px solid #0086ab' : 'none',
                      borderRadius: '6px 6px 0 0',
                      cursor: 'pointer',
                      fontSize: '13px',
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    <i className="ti ti-lock"></i>
                    Garantías
                  </button>
                  <button
                    onClick={() => setTabGarantias('bonos')}
                    style={{
                      padding: '12px 16px',
                      background: tabGarantias === 'bonos' ? '#0086ab' : 'transparent',
                      color: tabGarantias === 'bonos' ? 'white' : '#6b7280',
                      border: 'none',
                      borderBottom: tabGarantias === 'bonos' ? '2px solid #0086ab' : 'none',
                      borderRadius: '6px 6px 0 0',
                      cursor: 'pointer',
                      fontSize: '13px',
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    <i className="ti ti-gift"></i>
                    Bono de Recomendación
                  </button>
                  <button
                    onClick={() => {
                      setTabGarantias('reportes');
                      cargarReporte();
                    }}
                    style={{
                      padding: '12px 16px',
                      background: tabGarantias === 'reportes' ? '#0086ab' : 'transparent',
                      color: tabGarantias === 'reportes' ? 'white' : '#6b7280',
                      border: 'none',
                      borderBottom: tabGarantias === 'reportes' ? '2px solid #0086ab' : 'none',
                      borderRadius: '6px 6px 0 0',
                      cursor: 'pointer',
                      fontSize: '13px',
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    <i className="ti ti-chart-bar"></i>
                    Reportes
                  </button>
                </div>
              </div>

              {/* Tab A: Garantías */}
              {tabGarantias === 'garantias' && (
                <div>
                  {/* Summary Cards */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                    gap: '12px',
                    marginBottom: '20px'
                  }}>
                    {/* Vigentes - Green */}
                    <div style={{
                      background: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      color: 'white',
                      boxShadow: '0 2px 8px rgba(16, 185, 129, 0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(16, 185, 129, 0.3)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.2)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', opacity: 0.9 }}>Vigentes</span>
                        <i className="ti ti-shield-check" style={{ fontSize: '16px' }}></i>
                      </div>
                      <div style={{ fontSize: '20px', fontWeight: 800 }}>{calcularResumenGarantias().vigentes}</div>
                    </div>

                    {/* Próximas - Amber */}
                    <div style={{
                      background: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      color: 'white',
                      boxShadow: '0 2px 8px rgba(245, 158, 11, 0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(245, 158, 11, 0.3)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(245, 158, 11, 0.2)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', opacity: 0.9 }}>Próximas</span>
                        <i className="ti ti-alert-triangle" style={{ fontSize: '16px' }}></i>
                      </div>
                      <div style={{ fontSize: '20px', fontWeight: 800 }}>{calcularResumenGarantias().proximas}</div>
                    </div>

                    {/* Vencidas - Red */}
                    <div style={{
                      background: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      color: 'white',
                      boxShadow: '0 2px 8px rgba(239, 68, 68, 0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(239, 68, 68, 0.3)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(239, 68, 68, 0.2)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', opacity: 0.9 }}>Vencidas</span>
                        <i className="ti ti-x-circle" style={{ fontSize: '16px' }}></i>
                      </div>
                      <div style={{ fontSize: '20px', fontWeight: 800 }}>{calcularResumenGarantias().vencidas}</div>
                    </div>

                    {/* Costo Total - Blue */}
                    <div style={{
                      background: 'linear-gradient(135deg, #0086ab 0%, #3cafd6 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      color: 'white',
                      boxShadow: '0 2px 8px rgba(0, 134, 171, 0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 134, 171, 0.3)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 134, 171, 0.2)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', opacity: 0.9 }}>Costo Total</span>
                        <i className="ti ti-coin" style={{ fontSize: '16px' }}></i>
                      </div>
                      <div style={{ fontSize: '14px', fontWeight: 800 }}>{formatCurrencyMX(calcularResumenGarantias().costoTotal)}</div>
                    </div>
                  </div>

                  {/* Filters */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '12px',
                    marginBottom: '16px',
                    padding: '12px',
                    background: '#f9fafb',
                    borderRadius: '8px'
                  }}>
                    <Select
                      label="Filtrar por Agencia"
                      name="filtro_agencia"
                      value={filtroGarantia.agencia}
                      onChange={(e) => setFiltroGarantia({ ...filtroGarantia, agencia: e.target.value })}
                      opciones={['JH Capital', 'Celta']}
                    />
                    <Select
                      label="Filtrar por Estado"
                      name="filtro_estado_gto"
                      value={filtroGarantia.estado}
                      onChange={(e) => setFiltroGarantia({ ...filtroGarantia, estado: e.target.value })}
                      opciones={['Vigente', 'Próxima a Vencer', 'Vencida']}
                    />
                  </div>

                  {/* Table */}
                  <div style={{ overflowX: 'auto' }}>
                    <table className="tabla">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Nombre</th>
                          <th>Puesto</th>
                          <th>Agencia</th>
                          <th>Ingreso</th>
                          <th>Período</th>
                          <th>Vencimiento</th>
                          <th>Costo</th>
                          <th>Días Restantes</th>
                          <th>Estado</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filtrarGarantias().map(g => {
                          const diasRestantes = calcularDiasRestantes(g.fecha_vencimiento);
                          const estado = getEstadoGarantia(diasRestantes);
                          const color = getColorEstadoGarantia(diasRestantes);

                          return (
                            <tr
                              key={g.id_garantia}
                              style={{
                                background: estado === 'Vigente' ? '#f0fdf4' : estado === 'Próxima a Vencer' ? '#fffbeb' : '#fef2f2',
                                borderLeft: `3px solid ${color}`
                              }}
                            >
                              <td style={{ fontWeight: 600, color: '#0086ab' }}>#{g.id_garantia}</td>
                              <td>{g.nombre}</td>
                              <td style={{ fontSize: '11px' }}>{g.puesto}</td>
                              <td style={{ fontSize: '11px' }}>{g.agencia}</td>
                              <td>{fmtFecha(g.fecha_ingreso)}</td>
                              <td style={{ fontSize: '11px', textAlign: 'center' }}>{g.periodo_garantia} días</td>
                              <td>{fmtFecha(g.fecha_vencimiento)}</td>
                              <td style={{ fontWeight: 600 }}>${g.costo_ingreso.toLocaleString('es-MX')}</td>
                              <td style={{ textAlign: 'center', fontWeight: 600, color }}>{diasRestantes > 0 ? diasRestantes : 0}</td>
                              <td>
                                <span
                                  style={{
                                    display: 'inline-block',
                                    padding: '4px 10px',
                                    borderRadius: '20px',
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    background: color + '20',
                                    color: color
                                  }}
                                >
                                  {estado}
                                </span>
                              </td>
                              <td>
                                <button
                                  onClick={() => setShowDetalleGarantia(g)}
                                  style={{
                                    padding: '4px 8px',
                                    background: '#0086ab',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    fontSize: '11px',
                                    cursor: 'pointer'
                                  }}
                                >
                                  <i className="ti ti-eye"></i> Ver
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {filtrarGarantias().length === 0 && (
                      <div style={{
                        textAlign: 'center',
                        padding: '40px 20px',
                        color: '#6b7280',
                        fontSize: '13px'
                      }}>
                        <i className="ti ti-inbox" style={{ fontSize: '32px', display: 'block', marginBottom: '8px', opacity: 0.4 }}></i>
                        No hay garantías registradas
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Tab B: Bonos */}
              {tabGarantias === 'bonos' && (
                <div>
                  {/* Summary Cards */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                    gap: '12px',
                    marginBottom: '20px'
                  }}>
                    {/* Total Pendientes - Red */}
                    <div style={{
                      background: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      color: 'white',
                      boxShadow: '0 2px 8px rgba(239, 68, 68, 0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(239, 68, 68, 0.3)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(239, 68, 68, 0.2)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', opacity: 0.9 }}>Total Pendientes</span>
                        <i className="ti ti-clock" style={{ fontSize: '16px' }}></i>
                      </div>
                      <div style={{ fontSize: '20px', fontWeight: 800 }}>{calcularResumenBonos().bonosPendientes}</div>
                    </div>

                    {/* Monto Total Pendiente - Blue */}
                    <div style={{
                      background: 'linear-gradient(135deg, #0086ab 0%, #3cafd6 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      color: 'white',
                      boxShadow: '0 2px 8px rgba(0, 134, 171, 0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 134, 171, 0.3)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 134, 171, 0.2)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', opacity: 0.9 }}>Monto Total Pendiente</span>
                        <i className="ti ti-wallet" style={{ fontSize: '16px' }}></i>
                      </div>
                      <div style={{ fontSize: '14px', fontWeight: 800 }}>{formatCurrencyMX(calcularResumenBonos().totalPendiente)}</div>
                    </div>

                    {/* Pagados - Green */}
                    <div style={{
                      background: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      color: 'white',
                      boxShadow: '0 2px 8px rgba(16, 185, 129, 0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(16, 185, 129, 0.3)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.2)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', opacity: 0.9 }}>Pagados</span>
                        <i className="ti ti-check-circle" style={{ fontSize: '16px' }}></i>
                      </div>
                      <div style={{ fontSize: '20px', fontWeight: 800 }}>{calcularResumenBonos().pagadosEsteMes}</div>
                    </div>
                  </div>

                  {/* Filters */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '12px',
                    marginBottom: '16px',
                    padding: '12px',
                    background: '#f9fafb',
                    borderRadius: '8px'
                  }}>
                    <Select
                      label="Filtrar por Estado Primer Pago"
                      name="filtro_pago_1"
                      value={filtroBono.estado_primer}
                      onChange={(e) => setFiltroBono({ ...filtroBono, estado_primer: e.target.value })}
                      opciones={['Pendiente', 'Pagado', 'Cancelado']}
                    />
                    <Select
                      label="Filtrar por Estado Segundo Pago"
                      name="filtro_pago_2"
                      value={filtroBono.estado_segundo}
                      onChange={(e) => setFiltroBono({ ...filtroBono, estado_segundo: e.target.value })}
                      opciones={['Pendiente', 'Pagado', 'Cancelado']}
                    />
                  </div>

                  {/* Table */}
                  <div style={{ overflowX: 'auto' }}>
                    <table className="tabla">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Recomendante</th>
                          <th>Recomendado</th>
                          <th>Ingreso</th>
                          <th>Monto 1° Mes</th>
                          <th>Estatus 1° Mes</th>
                          <th>Monto 3° Mes</th>
                          <th>Estatus 3° Mes</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filtrarBonos().map(b => (
                          <tr key={b.id_bono}>
                            <td style={{ fontWeight: 600, color: '#0086ab' }}>#{b.id_bono}</td>
                            <td>{b.nombre_recomendante}</td>
                            <td>{b.nombre_recomendado}</td>
                            <td>{fmtFecha(b.fecha_ingreso_recomendado)}</td>
                            <td>${b.monto_primer_pago.toLocaleString('es-MX')}</td>
                            <td>
                              <span
                                style={{
                                  display: 'inline-block',
                                  padding: '4px 10px',
                                  borderRadius: '20px',
                                  fontSize: '11px',
                                  fontWeight: 600,
                                  background: b.estado_primer_pago === 'Pendiente' ? '#fef2f2' : b.estado_primer_pago === 'Pagado' ? '#ecfdf5' : '#f3f4f6',
                                  color: b.estado_primer_pago === 'Pendiente' ? '#dc2626' : b.estado_primer_pago === 'Pagado' ? '#10b981' : '#6b7280'
                                }}
                              >
                                {b.estado_primer_pago === 'Pendiente' && <i className="ti ti-clock" style={{ marginRight: '4px' }}></i>}
                                {b.estado_primer_pago === 'Pagado' && <i className="ti ti-check" style={{ marginRight: '4px' }}></i>}
                                {b.estado_primer_pago === 'Cancelado' && <i className="ti ti-x" style={{ marginRight: '4px' }}></i>}
                                {b.estado_primer_pago}
                              </span>
                            </td>
                            <td>${b.monto_segundo_pago.toLocaleString('es-MX')}</td>
                            <td>
                              <span
                                style={{
                                  display: 'inline-block',
                                  padding: '4px 10px',
                                  borderRadius: '20px',
                                  fontSize: '11px',
                                  fontWeight: 600,
                                  background: b.estado_segundo_pago === 'Pendiente' ? '#fef2f2' : b.estado_segundo_pago === 'Pagado' ? '#ecfdf5' : '#f3f4f6',
                                  color: b.estado_segundo_pago === 'Pendiente' ? '#dc2626' : b.estado_segundo_pago === 'Pagado' ? '#10b981' : '#6b7280'
                                }}
                              >
                                {b.estado_segundo_pago === 'Pendiente' && <i className="ti ti-clock" style={{ marginRight: '4px' }}></i>}
                                {b.estado_segundo_pago === 'Pagado' && <i className="ti ti-check" style={{ marginRight: '4px' }}></i>}
                                {b.estado_segundo_pago === 'Cancelado' && <i className="ti ti-x" style={{ marginRight: '4px' }}></i>}
                                {b.estado_segundo_pago}
                              </span>
                            </td>
                            <td>
                              <div style={{ display: 'flex', gap: '4px' }}>
                                {b.estado_primer_pago === 'Pendiente' && (
                                  <button
                                    onClick={() => setShowConfirmPago({ bono_id: b.id_bono, pago_numero: 1, monto: b.monto_primer_pago, recomendante: b.nombre_recomendante, recomendado: b.nombre_recomendado })}
                                    style={{
                                      padding: '4px 8px',
                                      background: '#10b981',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '4px',
                                      fontSize: '11px',
                                      cursor: 'pointer'
                                    }}
                                  >
                                    <i className="ti ti-cash"></i> Confirmar pago
                                  </button>
                                )}
                                {b.estado_segundo_pago === 'Pendiente' && puedepagarSegundoPago(b.fecha_ingreso_recomendado) && (
                                  <button
                                    onClick={() => setShowConfirmPago({ bono_id: b.id_bono, pago_numero: 2, monto: b.monto_segundo_pago, recomendante: b.nombre_recomendante, recomendado: b.nombre_recomendado })}
                                    style={{
                                      padding: '4px 8px',
                                      background: '#10b981',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '4px',
                                      fontSize: '11px',
                                      cursor: 'pointer'
                                    }}
                                  >
                                    <i className="ti ti-cash"></i> Confirmar pago
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {filtrarBonos().length === 0 && (
                      <div style={{
                        textAlign: 'center',
                        padding: '40px 20px',
                        color: '#6b7280',
                        fontSize: '13px'
                      }}>
                        <i className="ti ti-inbox" style={{ fontSize: '32px', display: 'block', marginBottom: '8px', opacity: 0.4 }}></i>
                        No hay bonos registrados
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Tab C: Reportes */}
              {tabGarantias === 'reportes' && (
                <div>
                  {/* Report Type Selector */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '12px',
                    marginBottom: '16px',
                    padding: '12px',
                    background: '#f9fafb',
                    borderRadius: '8px'
                  }}>
                    <Select
                      label="Tipo de Reporte"
                      name="reporte_type"
                      value={reporteType}
                      onChange={(e) => {
                        setReporteType(e.target.value);
                        setReporteData(null);
                      }}
                      opciones={[
                        { value: 'garantias', label: 'Garantías por Agencia' },
                        { value: 'gastos', label: 'Gastos de Reclutamiento' },
                        { value: 'avanza', label: 'Control AVANZA' }
                      ]}
                    />
                    <Select
                      label="Período"
                      name="periodo"
                      value={periodoReporte}
                      onChange={(e) => setPeriodoReporte(e.target.value)}
                      opciones={[
                        { value: 'mes-actual', label: 'Este Mes' },
                        { value: 'ultimos-3', label: 'Últimos 3 Meses' },
                        { value: 'ultimos-6', label: 'Últimos 6 Meses' },
                        { value: 'todo', label: 'Todo' }
                      ]}
                    />
                    <div style={{ display: 'flex', gap: '6px', alignItems: 'flex-end' }}>
                      <button
                        onClick={cargarReporte}
                        disabled={loading}
                        style={{
                          flex: 1,
                          padding: '8px 12px',
                          background: '#0086ab',
                          color: 'white',
                          border: 'none',
                          borderRadius: '6px',
                          fontSize: '12px',
                          fontWeight: 600,
                          cursor: loading ? 'not-allowed' : 'pointer',
                          opacity: loading ? 0.6 : 1
                        }}
                      >
                        <i className="ti ti-refresh"></i> Cargar
                      </button>
                      <button
                        onClick={() => exportarReporte('csv')}
                        style={{
                          padding: '8px 12px',
                          background: '#10b981',
                          color: 'white',
                          border: 'none',
                          borderRadius: '6px',
                          fontSize: '12px',
                          fontWeight: 600,
                          cursor: 'pointer'
                        }}
                      >
                        <i className="ti ti-download"></i> CSV
                      </button>
                    </div>
                  </div>

                  {/* Report Data */}
                  {reporteData && (
                    <div>
                      {reporteData.tipo === 'garantias' && (
                        <div style={{ overflowX: 'auto' }}>
                          <table className="tabla">
                            <thead>
                              <tr>
                                <th>Agencia</th>
                                <th>Total Garantías</th>
                                <th>Costo Total</th>
                                <th>Vigentes</th>
                                <th>Vencidas</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reporteData.datos.map((row, idx) => (
                                <tr key={idx}>
                                  <td style={{ fontWeight: 600 }}>{row.agencia}</td>
                                  <td>{row.total_garantias}</td>
                                  <td>${row.costo_total.toLocaleString('es-MX')}</td>
                                  <td><span style={{ color: '#10b981', fontWeight: 600 }}>{row.vigentes}</span></td>
                                  <td><span style={{ color: '#ef4444', fontWeight: 600 }}>{row.vencidas}</span></td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}

                      {reporteData.tipo === 'gastos' && (
                        <div style={{ overflowX: 'auto' }}>
                          <table className="tabla">
                            <thead>
                              <tr>
                                <th>Tipo de Gasto</th>
                                <th>Total</th>
                                <th>Cantidad</th>
                                <th>Promedio</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reporteData.datos.map((row, idx) => (
                                <tr key={idx}>
                                  <td style={{ fontWeight: 600 }}>{row.tipo_gasto}</td>
                                  <td>${row.total.toLocaleString('es-MX')}</td>
                                  <td>{row.cantidad}</td>
                                  <td>${row.promedio.toLocaleString('es-MX')}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}

                      {reporteData.tipo === 'avanza' && (
                        <div style={{ overflowX: 'auto' }}>
                          <table className="tabla">
                            <thead>
                              <tr>
                                <th>Agente</th>
                                <th>Salidas</th>
                                <th>KM Total</th>
                                <th>Prospectos</th>
                                <th>Volantes</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reporteData.datos.map((row, idx) => (
                                <tr key={idx}>
                                  <td style={{ fontWeight: 600 }}>{row.agente}</td>
                                  <td>{row.salidas}</td>
                                  <td>{row.km_total.toLocaleString('es-MX')}</td>
                                  <td>{row.prospectos}</td>
                                  <td>{row.volantes.toLocaleString('es-MX')}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}

                  {!reporteData && (
                    <div style={{
                      textAlign: 'center',
                      padding: '40px 20px',
                      color: '#6b7280',
                      background: '#f9fafb',
                      borderRadius: '8px'
                    }}>
                      <i className="ti ti-chart-bar" style={{ fontSize: '32px', display: 'block', marginBottom: '8px', opacity: 0.4 }}></i>
                      <p style={{ margin: '0', fontSize: '13px' }}>Selecciona un reporte y período para ver datos</p>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Detalle Garantía Modal */}
            {showDetalleGarantia && (
              <div className="modal-overlay" onClick={() => setShowDetalleGarantia(null)}>
                <div className="modal" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-header">
                    <h2>
                      <i className="ti ti-shield"></i> Detalle de Garantía
                    </h2>
                    <button
                      className="modal-close"
                      onClick={() => setShowDetalleGarantia(null)}
                    >
                      ✕
                    </button>
                  </div>
                  <div className="modal-body">
                    <SeccionLabel icon="ti-user">Información del Empleado</SeccionLabel>
                    <div className="info-grid">
                      <InfoCampo label="ID Garantía" valor={showDetalleGarantia.id_garantia} />
                      <InfoCampo label="Nombre" valor={showDetalleGarantia.nombre} />
                      <InfoCampo label="Puesto" valor={showDetalleGarantia.puesto} />
                      <InfoCampo label="Fecha Ingreso" valor={fmtFecha(showDetalleGarantia.fecha_ingreso)} />
                    </div>

                    <SeccionLabel icon="ti-building">Información de la Agencia</SeccionLabel>
                    <div className="info-grid">
                      <InfoCampo label="Agencia" valor={showDetalleGarantia.agencia} />
                    </div>

                    <SeccionLabel icon="ti-lock">Términos de Garantía</SeccionLabel>
                    <div className="info-grid">
                      <InfoCampo label="Período de Garantía" valor={`${showDetalleGarantia.periodo_garantia} días`} />
                      <InfoCampo label="Fecha Vencimiento" valor={fmtFecha(showDetalleGarantia.fecha_vencimiento)} />
                      <InfoCampo label="Costo" valor={`$${showDetalleGarantia.costo_ingreso.toLocaleString('es-MX')}`} highlight={true} />
                      <InfoCampo
                        label="Estado"
                        valor={getEstadoGarantia(calcularDiasRestantes(showDetalleGarantia.fecha_vencimiento))}
                      />
                    </div>

                    {getEstadoGarantia(calcularDiasRestantes(showDetalleGarantia.fecha_vencimiento)) === 'Vencida' && (
                      <div style={{
                        background: '#fef2f2',
                        border: '1px solid #fecaca',
                        borderRadius: '8px',
                        padding: '12px',
                        marginTop: '16px',
                        color: '#991b1b',
                        fontSize: '12px'
                      }}>
                        <i className="ti ti-alert-circle" style={{ marginRight: '6px' }}></i>
                        Esta garantía ha vencido. Contactar a la agencia para reactivación.
                      </div>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn-secondary"
                      onClick={() => setShowDetalleGarantia(null)}
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Confirmación Pago Modal */}
            {showConfirmPago && (
              <div className="modal-overlay" onClick={() => setShowConfirmPago(null)}>
                <div className="modal" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-header">
                    <h2>
                      <i className="ti ti-cash"></i> Confirmar Pago de Bono
                    </h2>
                    <button
                      className="modal-close"
                      onClick={() => setShowConfirmPago(null)}
                    >
                      ✕
                    </button>
                  </div>
                  <div className="modal-body">
                    <div style={{
                      background: '#eff6ff',
                      border: '1px solid #bfdbfe',
                      borderRadius: '8px',
                      padding: '16px',
                      marginBottom: '16px'
                    }}>
                      <div className="info-grid">
                        <InfoCampo label="Recomendante" valor={showConfirmPago.recomendante} />
                        <InfoCampo label="Recomendado" valor={showConfirmPago.recomendado} />
                        <InfoCampo label="Monto" valor={`$${showConfirmPago.monto.toLocaleString('es-MX')}`} highlight={true} />
                        <InfoCampo label="Pago #" valor={`${showConfirmPago.pago_numero} de 2`} />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn-secondary"
                      onClick={() => setShowConfirmPago(null)}
                      disabled={loadingBono}
                    >
                      Cancelar
                    </button>
                    <button
                      className="btn-primary"
                      onClick={() => procesarPagoBono(showConfirmPago.bono_id, showConfirmPago.pago_numero)}
                      disabled={loadingBono}
                      style={{ opacity: loadingBono ? 0.6 : 1 }}
                    >
                      {loadingBono ? (
                        <>
                          <i className="ti ti-loader-2"></i> Procesando...
                        </>
                      ) : (
                        <>
                          <i className="ti ti-check"></i> Confirmar Pago
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Control AVANZA Tab */}
        {activeTab === 'control-avanza' && (
          <div>
            {/* Success Message */}
            {successMessage && (
              <div style={{
                background: '#d1fae5',
                border: '1px solid #6ee7b7',
                borderRadius: '8px',
                padding: '12px 16px',
                marginBottom: '16px',
                color: '#065f46',
                fontSize: '13px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <i className="ti ti-check"></i>
                {successMessage}
              </div>
            )}

            {/* Monthly Summary - Moved to top */}
            {(() => {
              const resumen = calcularResumenMes();
              return (
                <div style={{ marginBottom: '24px' }}>
                  <div style={{ fontSize: '14px', fontWeight: 600, color: '#1d3d6b', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <i className="ti ti-calendar-stats"></i>
                    Resumen de {resumen.mes}
                  </div>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                    gap: '12px',
                    marginBottom: '24px'
                  }}>
                    {/* Total Salidas - Teal */}
                    <div style={{
                      background: 'linear-gradient(135deg, #0d9488 0%, #14b8a6 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      color: 'white',
                      boxShadow: '0 2px 8px rgba(13, 148, 136, 0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(13, 148, 136, 0.3)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(13, 148, 136, 0.2)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', opacity: 0.9 }}>Total Salidas</span>
                        <i className="ti ti-map-pin" style={{ fontSize: '16px' }}></i>
                      </div>
                      <div style={{ fontSize: '20px', fontWeight: 800 }}>{resumen.totalSalidas}</div>
                    </div>

                    {/* KM Total - Purple */}
                    <div style={{
                      background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      color: 'white',
                      boxShadow: '0 2px 8px rgba(124, 58, 237, 0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(124, 58, 237, 0.3)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(124, 58, 237, 0.2)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', opacity: 0.9 }}>KM Total</span>
                        <i className="ti ti-route" style={{ fontSize: '16px' }}></i>
                      </div>
                      <div style={{ fontSize: '20px', fontWeight: 800 }}>{resumen.totalKm.toLocaleString('es-MX')}</div>
                    </div>

                    {/* Costo Total - Red */}
                    <div style={{
                      background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      color: 'white',
                      boxShadow: '0 2px 8px rgba(220, 38, 38, 0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(220, 38, 38, 0.3)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(220, 38, 38, 0.2)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', opacity: 0.9 }}>Costo Total</span>
                        <i className="ti ti-coin" style={{ fontSize: '16px' }}></i>
                      </div>
                      <div style={{ fontSize: '14px', fontWeight: 800 }}>{formatCurrencyMX(resumen.totalCosto)}</div>
                    </div>

                    {/* Prospectos - Blue */}
                    <div style={{
                      background: 'linear-gradient(135deg, #0086ab 0%, #3cafd6 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      color: 'white',
                      boxShadow: '0 2px 8px rgba(0, 134, 171, 0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 134, 171, 0.3)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 134, 171, 0.2)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', opacity: 0.9 }}>Prospectos</span>
                        <i className="ti ti-target" style={{ fontSize: '16px' }}></i>
                      </div>
                      <div style={{ fontSize: '20px', fontWeight: 800 }}>{resumen.totalProspectos}</div>
                    </div>

                    {/* Volantes - Amber */}
                    <div style={{
                      background: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      color: 'white',
                      boxShadow: '0 2px 8px rgba(245, 158, 11, 0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(245, 158, 11, 0.3)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(245, 158, 11, 0.2)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', opacity: 0.9 }}>Volantes</span>
                        <i className="ti ti-file-text" style={{ fontSize: '16px' }}></i>
                      </div>
                      <div style={{ fontSize: '20px', fontWeight: 800 }}>{resumen.totalVolantes.toLocaleString('es-MX')}</div>
                    </div>

                    {/* Viáticos - Green */}
                    <div style={{
                      background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      color: 'white',
                      boxShadow: '0 2px 8px rgba(5, 150, 105, 0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(5, 150, 105, 0.3)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(5, 150, 105, 0.2)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', opacity: 0.9 }}>Viáticos</span>
                        <i className="ti ti-wallet" style={{ fontSize: '16px' }}></i>
                      </div>
                      <div style={{ fontSize: '14px', fontWeight: 800 }}>{formatCurrencyMX(resumen.totalViaticos)}</div>
                    </div>

                    {/* Diesel - Orange */}
                    <div style={{
                      background: 'linear-gradient(135deg, #ea580c 0%, #fb923c 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      color: 'white',
                      boxShadow: '0 2px 8px rgba(234, 88, 12, 0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(234, 88, 12, 0.3)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(234, 88, 12, 0.2)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', opacity: 0.9 }}>Diesel</span>
                        <i className="ti ti-fuel" style={{ fontSize: '16px' }}></i>
                      </div>
                      <div style={{ fontSize: '14px', fontWeight: 800 }}>{formatCurrencyMX(resumen.totalDiesel)}</div>
                    </div>
                  </div>
                </div>
              );
            })()}

            {/* Button to Open Form Modal */}
            <button
              onClick={() => setShowFormControlModal(true)}
              style={{
                padding: '10px 16px',
                background: '#0086ab',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '13px',
                fontWeight: 600,
                cursor: 'pointer',
                marginBottom: '24px',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <i className="ti ti-plus"></i>
              Registrar Actividad de Campo
            </button>

            {/* Form Section - Moved to modal below */}

            {/* Modal for Registrar Actividad de Campo */}
            {showFormControlModal && (
              <div className="modal-overlay" onClick={() => setShowFormControlModal(false)}>
                <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                  <div className="modal-header">
                    <h2>
                      <i className="ti ti-plus"></i> Registrar Actividad de Campo
                    </h2>
                    <button
                      className="modal-close"
                      onClick={() => setShowFormControlModal(false)}
                    >
                      ✕
                    </button>
                  </div>
                  <div className="modal-body">
                          {/* Row 1: Quien Salio & Fecha */}
                    <div className="form-grid">
                      <div>
                        <Input
                          label="Quién Salió *"
                          name="quien_salio"
                          value={formControl.quien_salio}
                          onChange={(e) => cambiarFormControl('quien_salio', e.target.value)}
                        />
                        {formControlErrors.quien_salio && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formControlErrors.quien_salio}</span>}
                      </div>
                      <div>
                        <Input
                          label="Fecha *"
                          name="fecha"
                          type="date"
                          value={formControl.fecha}
                          onChange={(e) => cambiarFormControl('fecha', e.target.value)}
                        />
                        {formControlErrors.fecha && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formControlErrors.fecha}</span>}
                      </div>
                    </div>

                    {/* Row 2: Horario Salida & Entrada */}
                    <div className="form-grid">
                      <div>
                        <Input
                          label="Horario Salida (HH:MM) *"
                          name="horario_salida"
                          type="time"
                          value={formControl.horario_salida}
                          onChange={(e) => cambiarFormControl('horario_salida', e.target.value)}
                        />
                        {formControlErrors.horario_salida && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formControlErrors.horario_salida}</span>}
                      </div>
                      <div>
                        <Input
                          label="Horario Entrada (HH:MM) *"
                          name="horario_entrada"
                          type="time"
                          value={formControl.horario_entrada}
                          onChange={(e) => cambiarFormControl('horario_entrada', e.target.value)}
                        />
                        {formControlErrors.horario_entrada && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formControlErrors.horario_entrada}</span>}
                      </div>
                    </div>

                    {/* Row 3: KM Inicio & Fin */}
                    <div className="form-grid">
                      <div>
                        <Input
                          label="KM Inicio (Odómetro) *"
                          name="km_inicio"
                          type="number"
                          value={formControl.km_inicio}
                          onChange={(e) => cambiarFormControl('km_inicio', e.target.value)}
                        />
                        {formControlErrors.km_inicio && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formControlErrors.km_inicio}</span>}
                      </div>
                      <div>
                        <Input
                          label="KM Fin (Odómetro) *"
                          name="km_fin"
                          type="number"
                          value={formControl.km_fin}
                          onChange={(e) => cambiarFormControl('km_fin', e.target.value)}
                        />
                        {formControlErrors.km_fin && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formControlErrors.km_fin}</span>}
                      </div>
                    </div>

                    {/* Row 4: Costo KM & Ubicación */}
                    <div className="form-grid">
                      <div>
                        <Input
                          label="Costo por KM ($)"
                          name="costo_km"
                          type="number"
                          step="0.01"
                          value={formControl.costo_km}
                          onChange={(e) => cambiarFormControl('costo_km', e.target.value)}
                        />
                      </div>
                      <div>
                        <Input
                          label="Ubicación / Zona *"
                          name="donde_fue"
                          value={formControl.donde_fue}
                          onChange={(e) => cambiarFormControl('donde_fue', e.target.value)}
                        />
                        {formControlErrors.donde_fue && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formControlErrors.donde_fue}</span>}
                      </div>
                    </div>

                    {/* Row 5: Prospectos & Volantes */}
                    <div className="form-grid">
                      <div>
                        <Input
                          label="Prospectos Contactados *"
                          name="prospectos_contactados"
                          type="number"
                          value={formControl.prospectos_contactados}
                          onChange={(e) => cambiarFormControl('prospectos_contactados', e.target.value)}
                        />
                        {formControlErrors.prospectos_contactados && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formControlErrors.prospectos_contactados}</span>}
                      </div>
                      <div>
                        <Input
                          label="Volantes Repartidos *"
                          name="volantes_repartidos"
                          type="number"
                          value={formControl.volantes_repartidos}
                          onChange={(e) => cambiarFormControl('volantes_repartidos', e.target.value)}
                        />
                        {formControlErrors.volantes_repartidos && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formControlErrors.volantes_repartidos}</span>}
                      </div>
                    </div>

                    {/* Row 6: Gastos */}
                    <div className="form-grid">
                      <div>
                        <Input
                          label="Gastos Viáticos (MXN)"
                          name="gastos_viaticos"
                          type="number"
                          step="0.01"
                          value={formControl.gastos_viaticos}
                          onChange={(e) => cambiarFormControl('gastos_viaticos', e.target.value)}
                        />
                      </div>
                      <div>
                        <Input
                          label="Gastos Diesel (MXN)"
                          name="gastos_diesel"
                          type="number"
                          step="0.01"
                          value={formControl.gastos_diesel}
                          onChange={(e) => cambiarFormControl('gastos_diesel', e.target.value)}
                        />
                      </div>
                      <div>
                        <Input
                          label="Gastos Otros (MXN)"
                          name="gastos_otros"
                          type="number"
                          step="0.01"
                          value={formControl.gastos_otros}
                          onChange={(e) => cambiarFormControl('gastos_otros', e.target.value)}
                        />
                      </div>
                    </div>

                    {/* Row 7: Resultados & Notas */}
                    <div className="form-grid">
                      <div style={{ gridColumn: '1 / -1' }}>
                        <Input
                          label="Resultados / Notas de Campo *"
                          name="resultados_notas"
                          value={formControl.resultados_notas}
                          onChange={(e) => cambiarFormControl('resultados_notas', e.target.value)}
                        />
                        {formControlErrors.resultados_notas && <span style={{ color: '#dc2626', fontSize: '12px' }}>{formControlErrors.resultados_notas}</span>}
                      </div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <Input
                          label="Notas Adicionales"
                          name="notas"
                          value={formControl.notas}
                          onChange={(e) => cambiarFormControl('notas', e.target.value)}
                        />
                      </div>
                    </div>

                    {/* Calculated Totals Display */}
                    <div style={{
                      background: '#eff6ff',
                      border: '1px solid #bfdbfe',
                      borderRadius: '8px',
                      padding: '16px',
                      marginTop: '16px',
                      display: 'grid',
                      gridTemplateColumns: 'repeat(3, 1fr)',
                      gap: '16px'
                    }}>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>KM Recorridos</div>
                        <div style={{ fontSize: '16px', fontWeight: 600, color: '#0086ab' }}>
                          {calculosControl.km_recorridos.toFixed(0)} km
                        </div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>Costo KM</div>
                        <div style={{ fontSize: '16px', fontWeight: 600, color: '#0086ab' }}>
                          ${(calculosControl.km_recorridos * parseFloat(formControl.costo_km)).toFixed(2)}
                        </div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>Costo Total Día</div>
                        <div style={{ fontSize: '16px', fontWeight: 600, color: '#10b981' }}>
                          ${calculosControl.costo_total_dia.toFixed(2)}
                        </div>
                      </div>
                    </div>

                    {/* Action Buttons */}
                    <div style={{
                      display: 'flex',
                      gap: '12px',
                      marginTop: '24px',
                      justifyContent: 'flex-end'
                    }}>
                      <button
                        onClick={resetFormControl}
                        style={{
                          padding: '8px 16px',
                          background: '#f3f4f6',
                          color: '#6b7280',
                          border: 'none',
                          borderRadius: '6px',
                          fontSize: '12px',
                          fontWeight: 600,
                          cursor: 'pointer'
                        }}
                      >
                        Limpiar
                      </button>
                      <button
                        onClick={guardarControlAvanza}
                        disabled={loading}
                        style={{
                          padding: '8px 16px',
                          background: '#10b981',
                          color: 'white',
                          border: 'none',
                          borderRadius: '6px',
                          fontSize: '12px',
                          fontWeight: 600,
                          cursor: loading ? 'not-allowed' : 'pointer',
                          opacity: loading ? 0.6 : 1,
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px'
                        }}
                      >
                        <i className="ti ti-device-floppy"></i>
                        Guardar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              )}

            {/* Table Section */}
            <div className="card">
              <div className="card-title">
                <i className="ti ti-table"></i>
                Listado de Actividades
              </div>

              {/* Filters */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '12px',
                marginBottom: '16px',
                padding: '12px',
                background: '#f9fafb',
                borderRadius: '8px'
              }}>
                <Select
                  label="Filtrar por Agente"
                  name="filtro_agente"
                  value={filtroControl.agente}
                  onChange={(e) => setFiltroControl({ ...filtroControl, agente: e.target.value })}
                  opciones={['', ...getAgentesUnicos()]}
                />
              </div>

              {/* Table */}
              <div style={{ overflowX: 'auto' }}>
                <table className="tabla">
                  <thead>
                    <tr>
                      <th style={{ width: '40px' }}></th>
                      <th
                        className="sortable"
                        onClick={() => cambiarOrdenamientoControl('id_control')}
                        style={{ cursor: 'pointer' }}
                      >
                        ID {sortControl.key === 'id_control' && (sortControl.direction === 'asc' ? '▲' : '▼')}
                      </th>
                      <th
                        className="sortable"
                        onClick={() => cambiarOrdenamientoControl('fecha')}
                        style={{ cursor: 'pointer' }}
                      >
                        Fecha {sortControl.key === 'fecha' && (sortControl.direction === 'asc' ? '▲' : '▼')}
                      </th>
                      <th>Día</th>
                      <th
                        className="sortable"
                        onClick={() => cambiarOrdenamientoControl('quien_salio')}
                        style={{ cursor: 'pointer' }}
                      >
                        Agente {sortControl.key === 'quien_salio' && (sortControl.direction === 'asc' ? '▲' : '▼')}
                      </th>
                      <th>Horario</th>
                      <th>KM</th>
                      <th>Costo/KM</th>
                      <th>Prospectos</th>
                      <th>Volantes</th>
                      <th
                        className="sortable"
                        onClick={() => cambiarOrdenamientoControl('costo_total_dia')}
                        style={{ cursor: 'pointer' }}
                      >
                        Total {sortControl.key === 'costo_total_dia' && (sortControl.direction === 'asc' ? '▲' : '▼')}
                      </th>
                      <th>Resultados</th>
                      <th style={{ width: '80px' }}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtrarControles().map((control) => (
                      <React.Fragment key={control.id_control}>
                        <tr style={{ background: expandedRows.has(control.id_control) ? '#f0fdfa' : '' }}>
                          <td>
                            <button
                              onClick={() => toggleExpandedRow(control.id_control)}
                              style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '16px',
                                color: '#0086ab'
                              }}
                            >
                              {expandedRows.has(control.id_control) ? '▼' : '▶'}
                            </button>
                          </td>
                          <td style={{ fontWeight: 600, color: '#0086ab' }}>{control.id_control}</td>
                          <td>{fmtFecha(control.fecha)}</td>
                          <td style={{ fontSize: '11px' }}>{getDiaSemana(control.fecha)}</td>
                          <td>{control.quien_salio}</td>
                          <td style={{ fontSize: '11px' }}>
                            {control.horario_salida} - {control.horario_entrada}
                          </td>
                          <td style={{ fontWeight: 600, color: '#0086ab' }}>{control.km_recorridos} km</td>
                          <td>${control.costo_km}</td>
                          <td>{control.prospectos_contactados}</td>
                          <td>{control.volantes_repartidos}</td>
                          <td style={{ fontWeight: 600, color: '#10b981' }}>
                            ${control.costo_total_dia.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                          </td>
                          <td style={{ fontSize: '11px', maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {control.resultados_notas}
                          </td>
                          <td>
                            <button
                              onClick={() => setShowDetalleControl(control)}
                              style={{
                                padding: '4px 8px',
                                background: '#3b82f6',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                fontSize: '11px',
                                cursor: 'pointer'
                              }}
                            >
                              <i className="ti ti-eye"></i> Detalles
                            </button>
                          </td>
                        </tr>
                        {expandedRows.has(control.id_control) && (
                          <tr style={{ background: '#f0fdfa', borderTop: '1px solid #14b8a6' }}>
                            <td colSpan="13" style={{ padding: '12px' }}>
                              <div>
                                <strong style={{ color: '#0d9488' }}>Resultados Completos:</strong>
                                <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#6b7280' }}>
                                  {control.resultados_notas}
                                </p>
                              </div>
                              {control.notas && (
                                <div style={{ marginTop: '8px' }}>
                                  <strong style={{ color: '#0d9488' }}>Notas Adicionales:</strong>
                                  <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#6b7280' }}>
                                    {control.notas}
                                  </p>
                                </div>
                              )}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
                {filtrarControles().length === 0 && (
                  <div style={{
                    textAlign: 'center',
                    padding: '40px 20px',
                    color: '#6b7280',
                    fontSize: '13px'
                  }}>
                    <i className="ti ti-inbox" style={{ fontSize: '32px', display: 'block', marginBottom: '8px', opacity: 0.4 }}></i>
                    No hay actividades registradas
                  </div>
                )}
              </div>
            </div>

            {/* Details Modal */}
            {showDetalleControl && (
              <div className="modal-overlay" onClick={() => setShowDetalleControl(null)}>
                <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
                  <div className="modal-header">
                    <h2>
                      <i className="ti ti-truck"></i> Control AVANZA {showDetalleControl.id_control}
                    </h2>
                    <button
                      className="modal-close"
                      onClick={() => setShowDetalleControl(null)}
                    >
                      ✕
                    </button>
                  </div>
                  <div className="modal-body">
                    {/* Section 1: Agent & Date Info */}
                    <div style={{ marginBottom: '16px' }}>
                      <h4 style={{ fontSize: '12px', fontWeight: 600, color: '#0d9488', marginBottom: '8px', textTransform: 'uppercase' }}>
                        Agente e Información de Fecha
                      </h4>
                      <div className="info-grid">
                        <InfoCampo label="Agente" valor={showDetalleControl.quien_salio} />
                        <InfoCampo label="Fecha" valor={fmtFecha(showDetalleControl.fecha)} />
                        <InfoCampo label="Día" valor={getDiaSemana(showDetalleControl.fecha)} />
                      </div>
                    </div>

                    {/* Section 2: Activity Details */}
                    <div style={{ marginBottom: '16px', borderTop: '1px solid #e5e7eb', paddingTop: '12px' }}>
                      <h4 style={{ fontSize: '12px', fontWeight: 600, color: '#0d9488', marginBottom: '8px', textTransform: 'uppercase' }}>
                        Detalles de Actividad
                      </h4>
                      <div className="info-grid">
                        <InfoCampo label="Salida" valor={showDetalleControl.horario_salida} />
                        <InfoCampo label="Entrada" valor={showDetalleControl.horario_entrada} />
                        <InfoCampo label="Ubicación" valor={showDetalleControl.donde_fue} />
                        <InfoCampo label="KM Recorridos" valor={`${showDetalleControl.km_recorridos} km`} />
                      </div>
                    </div>

                    {/* Section 3: Results & Prospecting */}
                    <div style={{ marginBottom: '16px', borderTop: '1px solid #e5e7eb', paddingTop: '12px' }}>
                      <h4 style={{ fontSize: '12px', fontWeight: 600, color: '#0d9488', marginBottom: '8px', textTransform: 'uppercase' }}>
                        Resultados y Prospección
                      </h4>
                      <div className="info-grid">
                        <InfoCampo label="Prospectos Contactados" valor={showDetalleControl.prospectos_contactados} />
                        <InfoCampo label="Volantes Repartidos" valor={showDetalleControl.volantes_repartidos} />
                      </div>
                      <div style={{ marginTop: '8px' }}>
                        <div style={{ fontSize: '12px', color: '#6b7280' }}>
                          <strong>Notas:</strong>
                          <p style={{ margin: '4px 0 0 0', fontSize: '12px', background: '#f9fafb', padding: '8px', borderRadius: '4px' }}>
                            {showDetalleControl.resultados_notas}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Section 4: Expenses */}
                    <div style={{ marginBottom: '16px', borderTop: '1px solid #e5e7eb', paddingTop: '12px' }}>
                      <h4 style={{ fontSize: '12px', fontWeight: 600, color: '#0d9488', marginBottom: '8px', textTransform: 'uppercase' }}>
                        Gastos
                      </h4>
                      <div className="info-grid">
                        <InfoCampo
                          label="KM Costo"
                          valor={`${showDetalleControl.km_recorridos} km × $${showDetalleControl.costo_km} = $${(showDetalleControl.km_recorridos * showDetalleControl.costo_km).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`}
                        />
                        <InfoCampo label="Viáticos" valor={`$${parseFloat(showDetalleControl.gastos_viaticos).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`} />
                        <InfoCampo label="Diesel" valor={`$${parseFloat(showDetalleControl.gastos_diesel).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`} />
                        <InfoCampo label="Otros" valor={`$${parseFloat(showDetalleControl.gastos_otros).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`} />
                      </div>
                      <div style={{
                        background: '#eff6ff',
                        border: '1px solid #bfdbfe',
                        borderRadius: '4px',
                        padding: '8px 12px',
                        marginTop: '8px',
                        fontSize: '12px',
                        fontWeight: 600,
                        color: '#0086ab'
                      }}>
                        TOTAL: ${showDetalleControl.costo_total_dia.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                      </div>
                    </div>

                    {/* Section 5: Auto-Created Expenses */}
                    <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '12px' }}>
                      <h4 style={{ fontSize: '12px', fontWeight: 600, color: '#0d9488', marginBottom: '8px', textTransform: 'uppercase' }}>
                        Gastos Autogenerados
                      </h4>
                      <div style={{ fontSize: '12px', color: '#6b7280' }}>
                        <p style={{ margin: '0 0 8px 0' }}>Se crearon registros en GASTOS_RECLUTAMIENTO:</p>
                        <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '11px' }}>
                          <li>GAS-### | KM_Avanza | ${(showDetalleControl.km_recorridos * showDetalleControl.costo_km).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</li>
                          {showDetalleControl.gastos_viaticos > 0 && (
                            <li>GAS-### | Viáticos_Reclutamiento | ${parseFloat(showDetalleControl.gastos_viaticos).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</li>
                          )}
                          {showDetalleControl.gastos_diesel > 0 && (
                            <li>GAS-### | Diesel_Avanza | ${parseFloat(showDetalleControl.gastos_diesel).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</li>
                          )}
                          {showDetalleControl.gastos_otros > 0 && (
                            <li>GAS-### | Otros_Avanza | ${parseFloat(showDetalleControl.gastos_otros).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn-secondary"
                      onClick={() => setShowDetalleControl(null)}
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Refresh Button */}
      <div style={{ marginTop: '24px', textAlign: 'right' }}>
        <button
          onClick={cargarKPIs}
          disabled={loading}
          style={{
            padding: '8px 16px',
            background: '#0086ab',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '13px',
            fontWeight: 600,
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.6 : 1
          }}
        >
          {loading ? (
            <>
              <i className="ti ti-loader-2" style={{ marginRight: '6px' }}></i>
              Actualizando...
            </>
          ) : (
            <>
              <i className="ti ti-refresh" style={{ marginRight: '6px' }}></i>
              Actualizar
            </>
          )}
        </button>
      </div>
    </div>
  );
}
